import { randomString } from 'sma.common/utils';
import Fields from './form-fields/base-field';

const l = require('lodash');
const Class = require('sma.fs/chide/class');
const chide = require('sma.fs/chide/ui');
const Javascripter = require('sma.fs/surveys/javascripter');
const Variable = require('sma.fs/surveys/variable');
const Validation = require('sma.fs/surveys/validation');
const { Option } = require('sma.fs/surveys/options');
const UploadField = require('./form-fields/file-upload/file-upload-wrapper');

Fields.SectionField = $.klass(Fields.Field, {
	type: 'section-separator',
	qlass: 'section-separator',
	cssType: 'field',

	displayName: gettext('Section Heading'),

	isQuestion: false,

	showOptions: function ($super, options) {
		$super(options);

		options.append(Option.renderGroup(gettext('Display'), [this.displayInline, this.appendToPrevious, this.widthOption], true));
	},
	serialize: function ($super) {
		return $.extend($super(), {
			children: []
		});
	}
});

Fields.JavaScript = $.klass(Fields.Field, {
	type: 'javascript',
	qlass: 'javascript',
	cssType: 'field',
	displayName: gettext('JavaScript'),
	helpText: gettext('Add custom JavaScript to your survey') +
		' ' +
		gettext('WARNING: Only use if you are familiar with JavaScript.' +
			'Any issues caused by the introduction of faulty JavaScript are the responsibilty of the user.'),
	isQuestion: false,
	options: $.extend({}, Fields.Field.prototype.options, {
		globalpiper: Class.create(chide.opts.Checkbox, {
			label: gettext('Limit Piper'),
			help: gettext('Limit Piper - Use a simplified piper list.'),
			changed: function (value) {
				this.field.javascripter.update_piper(this.field.survey, value, this.field.noids.value);
			}
		}),
		noids: Class.create(chide.opts.Checkbox, {
			label: gettext('Remove Question IDs'),
			help: gettext('Remove Question IDs - Limit piper list to piped variables and question answers.'),
			changed: function (value) {
				this.field.javascripter.update_piper(
					this.field.survey, this.field.globalpiper.value, value
				);
			}
		})
	}),

	initialize: function ($super, info, editor) {
		const that = this;
		$super(info, editor);

		info = info || {};

		this.info = info;
		this.editor = editor;
		this.survey = editor.survey;

		this.title = new (Class.create(chide.opts.Html, {
			label: gettext('Script Name'),
			changed: function (value) {
				$('.title', that.element).html(that.survey.stripScriptTags(value));
			}
		}))({
			value: info.title || gettext('JavaScript')
		});

		this.description = new (Class.create(chide.opts.Html, {
		}))({
			translatable: false,
			value: info.description || '$(function (){\n//place script here\n\n\n});'
		});

		this.globalpiper = new this.options.globalpiper({
			value: (info.globalpiper !== undefined) ? !!info.globalpiper : true,
			field: this
		});
		this.noids = new this.options.noids({ value: (info.noids !== undefined) ? !!info.noids : true, field: this });
	},

	showOptions: function ($super, options) {
		options.html('');
		options
			.append(this.name.render())
			.append(this.title.render());
		options.append(Option.renderGroup(gettext('Options'), [this.globalpiper, this.noids], true));
	},

	serialize: function ($super) {
		const result = $.extend($super(), {
			globalpiper: this.globalpiper.get(),
			noids: this.noids.get()
		});
		return result;
	},

	renderContent: function () { },

	render: function () {
		const that = this;

		this.javascripter = $('<div class="javascripter"/>')
			.attachAndReturn(Javascripter, this.survey, this.editor)[0];

		this.element.empty();

		const options = $('<div class="sma-js-field-actions"></div>')
			.append($(`<a data-variable-name="${this.id}"></a>`))
			.append($('<a href="#" class="nc-icon-mini gestures_drag-31 move" title=' +
				gettext('Move')+'></a>').tooltip())
			.append($('<a href="#" class="nc-icon-mini files_single-copy-04 duplicate" title=' +
				gettext('Duplicate')+'></a>').tooltip())
			.append($('<a href="#" class="nc-icon-mini ui-1_trash-simple remove" title=' +
				gettext('Delete')+'></a>').tooltip());

		this.element.append(options);

		this.element.append(
			'<span class="status"></span>',
			'<span class="name">' + ((that.name.get()) ? that.name.get() : '') + '</span>',
			'<span class="title fr-view">' + that.title.get() + '</span>',
			//'<div class="description">' + that.description.get() + '<\/div>',
			this.javascripter.element
		);

		const settings = {};
		settings['field'] = this;
		settings['globalpiper'] = this.globalpiper.value;
		settings['noids'] = this.noids.value;

		this.javascripter.set(settings);
		this.element.children('form').hide();

		this.renderContent();
	}
});

Fields.TextField = $.klass(Fields.Field, {
	type: 'text-response',
	qlass: 'text-response',
	cssType: 'text-response',

	displayName: gettext('Text Response'),
	isBranchable: true,

	supportedActions: Fields.Field.prototype.supportedActions.concat([
		Fields.Actions.looping
	]),

	options: $.extend({}, Fields.Field.prototype.options, {

		appearance: Class.create(chide.opts.Checkbox, {
			label: gettext('Multiline'),
			changed: function (_value) { this.field.renderContent(); },
			render: function ($super, field) {
				field = field || this.field;

				let rows = field.rows.render();
				let cols = field.cols.render();

				return $super([rows])
					.append(cols)
					.bind('changed', function (_e, _value) {
						if (field.cols.value === undefined) {
							cols.find('input').val(field.cols.get().toString());
						}

						if (field.rows.value === undefined) {
							rows.find('input').val(field.rows.get());
						}
					});
			}
		}),

		rows: Class.create(chide.opts.Number, {
			displayInline: true,
			inputClass: 'text inline short',
			label: gettext('Rows:'),
			max: 25,
			min: 1,
			type: 'int',
			changed: function (_value) { this.field.renderContent(); },
			get: function () { return this.value || 6; }
		}),

		cols: Class.create(chide.opts.Number, {
			displayInline: true,
			inputClass: 'text inline short',
			label: gettext('Columns:'),
			max: 100,
			min: 1,
			type: 'int',
			changed: function (_value) { this.field.renderContent(); },
			get: function () { return this.value || ((this.field.appearance.get()) ? 50 : 20); }
		}),

		initialValue: Class.create(chide.opts.Text, {
			displayInline: true,
			inputClass: 'text inline short',
			label: gettext('Initial Value'),
			help: gettext('About Initial Values - Initial values allow you to specify pre-populated answers to questions in your survey.'),
			inputClass: 'text short',
			changed: function (value) { this.field.input.val(value); }
		}),

		hide_input: Class.create(chide.opts.Checkbox, {
			label: gettext('Hide Input'),
			help: gettext('About Hide Input - When a user types in this input box, the text will appear as dots.'),
			changed: function (_value) { }
		}),

		restore_default: Class.create(chide.opts.Checkbox, {
			label: gettext('Restore Initial Value'),
			help: gettext('About Restore Initial Value - When a user comes back to this form page, this question will have its default value.'),
			changed: function (_value) { }
		})
	}),

	initialize: function ($super, info, editor) {
		const that = this;

		info = info || {};

		$super(info, editor);

		let validation;
		if (info.children && info.children.length) {
			if (info.children[0].validation && typeof(info.children[0].validation) == 'object') {
				validation = info.children[0].validation;
			} else {
				validation = {type:'none', minLength:'', maxLength:'', regex:'^.*$', errorMsg:{en:'Invalid Entry'}};
			}
		} else {
			validation = {type:'none', minLength:'0', maxLength:'', regex:'^.*$', errorMsg:{en:'Invalid Entry'}};
		}

		this.appearance = new this.options.appearance({
			field: this,
			value: (info.children && info.children.length) ? info.children[0].appearance === 'full' : false
		});

		this.rows = new this.options.rows({
			field: this,
			value: (info.children && info.children.length) ? info.children[0].rows : info.rows
		});

		this.cols = new this.options.cols({
			field: this,
			value: (info.children && info.children.length) ? info.children[0].cols : info.cols
		});

		this.optional = new this.options.optional({
			info: info,
			changed: function (_value) { that.render(); }
		});

		this.hide_input =  new this.options.hide_input({
			field: this,
			value: info.children &&
				info.children.length &&
				info.children[0].hide_input ||
				info.hide_input ||
				undefined
		});

		this.restore_default =  new this.options.restore_default({
			field: this,
			value: info.children &&
				info.children.length &&
				info.children[0].restore_default ||
				info.restore_default ||
				undefined
		});

		this.initialValue = new this.options.initialValue({
			field: this,
			value: info.children &&
				info.children.length &&
				info.children[0].initialValue ||
				info.initialValue ||
				undefined
		});

		this.validation = new Validation(this, {
			value: validation
		});

		this.prefix = $('<span></span>');
		this.suffix = $('<span></span>');

		this.validation.render();
	},

	getVariables: function () {
		return [new Variable.String({ id: this.id, label: this.getIdentifier() })];
	},

	getInput: function () {
		if (this.appearance.get()) {
			return $('<textarea/>', {
				rows: this.rows.get(),
				cols: this.cols.get()
			}).val(this.initialValue.get() || '');
		} else {
			return $('<input class="text" type="text" />')
				.css('width', (this.cols.get()) * 10 + 'px')
				.val(this.initialValue.get() || '');
		}
	},

	renderContent: function () {
		if (this.input) {
			this.input.remove();
		}

		this.input = this.getInput();

		this.element.append(
			this.prefix,
			this.input,
			this.suffix);
	},

	showOptions: function ($super, options) {
		let uiElements = [
			this.optional, this.hide_input, this.restore_default, this.validation.render(),
			this.initialValue
		];

		$super(options);

		options.append(
			Option.renderGroup(gettext('Display'), [
				this.appearance.render(this),
				this.displayInline,
				this.appendToPrevious,
				this.widthOption], true),
			Option.renderGroup(gettext('Options'), uiElements, true));
	},

	getExtractionOptions: function (config) {
		return new chide.opts.Number({
			showLabel: true,
			type: 'int',
			label: gettext('Maximum number of loop iterations:'),
			value: (config && config.max) || 10
		});
	},

	serializeExtractionOptions: function (options) {
		return {
			max: options.value
		};
	},

	serialize: function ($super) {
		return $.extend($super(), {
			children: [$.extend({}, {
				type: 'string',
				required: !this.optional.value,
				appearance: (this.appearance.value) ? 'full': undefined,
				rows: this.rows.value,
				cols: this.cols.value,
				validation: this.validation.value &&
					this.validation.value.type &&
					this.validation.value.type !== 'none' &&
					this.validation.get() || undefined,
				initialValue: this.initialValue.get() && this.initialValue.value || undefined,
				hide_input: this.hide_input.value,
				restore_default: this.restore_default.value
			})]
		});
	}
});

Fields.ChoiceField = $.klass(Fields.Field, {
	type: 'single-choice',
	qlass: 'single-choice',
	cssType: 'choice',

	displayName: gettext('Multiple Choice'),
	inputType: 'radio',

	extraDisplay: null,

	hasOther: true,
	hasStatic: true,
	hasNA: false,
	hasCheckAll: false,
	hasChoiceChildren: true,
	hasChoiceBranching: false,
	multiSelect: false,
	maxPerCombo: 15,
	displayAsCombo: false,

	isScorable: true,

	options: $.extend({}, Fields.Field.prototype.options, {
		appearance: Class.create(chide.opts.Single, {
			label: gettext('Appearance'),
			changed: function (value) { this.field.renderContent(); },
			choices: [
				['default', gettext('Default')],
				['horizontal', gettext('Horizontal')],
				['combo', gettext('Combo box')]
			]
		}),

		columns: Class.create(chide.opts.Single, {
			label: gettext('Columns'),
			help: gettext('About columns - This number will determine how many columns these choices should be displayed in. Preview is not available for this function.'),
			choices: [
				[1, '1'],
				[2, '2'],
				[3, '3'],
				[4, '4'],
				[5, '5']
			]
		}),

		randomize: Class.create(chide.opts.Checkbox, {
			label: gettext('Randomize choices'),
			help: gettext('About Randomize - Check this option if you would like this question\'s choices to be shown in a random order every time the page is viewed.'),
			changed: function (value) {
				if (value) {
					this.field.alphabetize && this.field.alphabetize.set(false).refresh();
				}
			}
		}),

		alphabetize: Class.create(chide.opts.Checkbox, {
			label: gettext('Alphabetize choices'),
			help: gettext('About Alphabetization - Check this option if you would like this question\'s choices to be shown in alphabetical order.'),
			changed: function (value) { if (value) { this.field.randomize && this.field.randomize.set(false).refresh(); } }
		}),

		show_range: Class.create(chide.opts.Checkbox, {
			label: gettext('Show number of options checked'),
			help: gettext('About Show Range - Shows the number of checkboxes that have been checked. Great to use if you restrict the number of selected choices.'),
			changed: function (value) { if (value) { this.show_range && this.show_range.set(false).refresh(); } }
		}),

		choiceList: Class.create(chide.opts.TextList, {

			hasSubOptions: true,
			score: Class.create(chide.opts.Number, {
				label: gettext('Score'),
				help: gettext('About Scoring - Scoring allows you to assign a value to each choice (for use with analytics).'),
				applyEdit: true,
				defaultBlank: true,
				clearValue: 0,
				blankText: function (index) {
					return index + 1;
				},
				changed: function (value) {
					this.field.renderContent();
				},
				initialize: function($super, config) {
					$super(config);
					if (config.min !== null) {
						if (Number.isInteger(config.min)) {
							this.min = config.min;
						}
						// Am not setting value for min otherwise as will default to call defaults
					}
				}
			}),

			other: Class.create(chide.opts.Checkbox, {
				label: gettext('Add text response'),
				changed: function (value) {
					if (value) { this.field.other_required && this.field.other_required.rendered && this.field.other_required.rendered.toggle(value); }
				}
			}),

			static: Class.create(chide.opts.Checkbox, {
				label: gettext('Static Choice'),
				changed: function (value) {
					//if (value) { this.field.static && this.field.other_required.rendered && this.field.other_required.rendered.toggle(value); }
				}
			}),

			na: Class.create(chide.opts.Checkbox, {
				label: gettext('Exclusive choice'),
				changed: function (value) { if (value) { this.field.check_all && this.field.check_all.set(false).refresh(); } }
			}),

			check_all: Class.create(chide.opts.Checkbox, {
				label: gettext('Select All'),
				help: gettext('About Check All - If this option is checked, when the user selects this choice, all other choices are selected.'),
				changed: function (value) { if (value) { this.field.na && this.field.na.set(false).refresh(); } }
			}),

			other_required: Class.create(chide.opts.Checkbox, {
				label: gettext('Make text response mandatory'),
				help: gettext('About Required response - If this option is checked, if the user selects this option, the text field is required.')
			}),

			itemFromValue: function(value) {
				var Branching = require('sma.fs/surveys/advanced').Branching;
				var that = this;
				var item = {};

				item = $.extend(item,{
					static : (this.field.hasStatic) ? new this.static({
						value: (value && value.static !== undefined) ? !!value.static : false
					}) : undefined,
					text: new this.textClass({ value: (value && value.label) ? value.label : '' }),
					score: new this.score({
						value: ((value !== undefined && value !== null && value != '') && value.score !== undefined && value.score !== '') ? value.score : undefined,
						min: this.field.editor.isReviewerForm ? 0 : null
					}),
					other: (this.field.hasOther) ? new this.other({
						value: (value && value.other !== undefined) ? !!value.other : false,
						changed: function (value) {
							that.itemChanged(that.value.indexOf(item), item);
							item.other_required && item.other_required.rendered && item.other_required.rendered.toggle(value);
						}
					}) : undefined,
					validation: (this.field.hasOther) ? new Validation(this.field, { value: (value) ? value.validation : undefined }) : undefined,
					na: (this.field.hasNA) ? new this.na({ value: (value && value.na !== undefined) ? !!value.na : false, field:item}) : undefined,
					check_all: (this.field.hasCheckAll) ? new this.check_all({ value: (value && value.check_all !== undefined) ? !!value.check_all : false, field:item }) : undefined,
					other_required: (this.field.hasOther) ? new this.other_required({
						value: (value && value.other_required !== undefined) ? !!value.other_required : false,
						field:item,
						changed: function (value) {
							return false;
						}
					}) : undefined,
					branching: (this.field.hasChoiceBranching) ? new Branching.Simple.Rule({ field: this.field, value: (value && value.branching) ? value.branching : undefined }) : undefined
				});

				item.score.field = this.field;

				return item;
			},

			renderSubOptions: function($super, item, index) {
				var sub = $super(item, index);

				if (this.field.hasNA) {
					sub.append(item.na.render());
				}
				if (this.field.hasCheckAll) {
					sub.append(item.check_all.render());
				}
				if (this.field.hasOther) {
					sub.append(item.other.render([item.validation]));
					sub.append((item.other_required.rendered = item.other_required.render()).toggle(item.other.get()));
				}
				if (this.field.hasStatic){
					sub.append(item.static.render());
				}

				sub.append(item.score.render(index));

				if (this.field.hasChoiceBranching) {
					sub.append(item.branching.render());
				}

				return sub;
			},

			itemAdded: function (item) { this.field.choiceAdded(item); },
			itemChanged: function (index, value) { this.field.choiceChanged(index, value); },
			itemRemoved: function (index) { this.field.choiceRemoved(index); },
			itemsChanged: function (value) { this.field.initialValue && this.field.initialValue.refresh(); this.field.renderContent(); }
		}),

		initialValue: Class.create(chide.opts.Select, {
			label: gettext('Initial Value'),
			help: gettext('About Initial Values - Initial values allow you to specify pre-populated answers to questions in your survey.'),
			renderChoices: function () {
				var choices = [];
				var value = this.field.choices.value;

				for (var i = 0; i < value.length; i++) {
					choices.push([i, _.unescape(value[i].text.get())]);
				}

				return chide.opts.renderSelect(choices, '---');
			},
			render: function ($super) {
				return (this.rendered = $super());
			},
			refresh: function () {
				var old = this.rendered;
				if (old) {
					this.rendered = undefined;
					old.replaceWith(this.render());
				}
			},
			changed: function (value) {
				if (value) {
					this.value = parseInt(value, 10);
					this.field.choiceDisplay && this.field.choiceDisplay.children(':not(.blank)').eq(value).attr('checked', true).attr('selected', true);
				} else {
					this.value = undefined;
				}
			}
		})
	}),

	initialize: function ($super, info, editor) {
		var that = this;
		info = info || {};

		$super(info, editor);

		var choices;

		if (info.choices) {
			choices = info.choices;
		} else if (info.children && info.children.length && info.children[0].choices) {
			choices = info.children[0].choices;
		} else {
			choices = [{label: gettext('Choice 1')}, {label: gettext('Choice 2')}];
		}

		var extraction = (info.extraction) ? info.extraction : (info.children && info.children.length) ? info.children[0].extraction : undefined;

		var appearance = (info.appearance) ? info.appearance : (info.children && info.children.length) ? info.children[0].choiceAppearance : 'default';

		// pre-2.0 compatibility
		if (this.hasOther && info.children && info.children.length && info.children[0].other) {
			choices.push({
				label: info.children[0].otherlabel || gettext('Other, please specify:'),
				other: true
			});
		}

		// pre-2.0 compatibility
		if (this.hasNA && info.children && info.children.length && info.children[0].NA) {
			choices.push({
				label: info.children[0].NA.text || gettext('Not Applicable'),
				na: true,
				score: info.children[0].NA.score
			});
		}

		// convert old branching
		if (this.hasChoiceBranching) {
			var branching = (info.children && info.children.length && info.children[0].branch) ? info.children[0].branch : undefined;

			if (branching) {
				for (var i = 0; i < branching.length; i++) {
					var j = branching[i].val;
					if (j >= 0 && j < choices.length) {
						choices[j].branching = branching[i].page;
					}
				}
			}
		}

		this.appearance = (this.options.appearance) ? new this.options.appearance({ value: appearance, field: this }) : undefined;

		this.choices = new this.options.choiceList({ value: choices, extraction: extraction, field: this });

		this.columns = (this.options.columns) ? new this.options.columns({ value: (info.children && info.children[0]) ? info.children[0].columns : info.columns }) : undefined;

		this.optional = new this.options.optional({ info: info, changed: function (value) {that.render();}});

		this.randomize = new this.options.randomize({ field:this, value: (info.children && info.children[0]) ? !!info.children[0].randomize : !!info.randomize });

		this.alphabetize = new this.options.alphabetize({ field:this, value: (info.children && info.children[0]) ? !!info.children[0].alphabetize : !!info.alphabetize });

		this.initialValue = (this.options.initialValue) ? new this.options.initialValue({ field: this, value: (info.children && info.children[0] && info.children[0].initialValue !== undefined && info.children[0].initialValue !== false) ? info.children[0].initialValue : undefined }) : undefined;
	},

	getVariables: function () {
		return [new Variable.Single({ id: this.id, label: this.getIdentifier(), choices: $.map(this.choices.get(), function (el) { return el.text.get(); }) })];
	},

	choiceAdded: function (item) {
		this.choiceDisplay && this.choiceDisplay.append(this.renderChoice(item));

		if (this.appearance && this.appearance.get() === 'combo') {
			this.choiceDisplay.attr('size', Math.min(this.maxPerCombo, this.choices.value.length));
		}

		// could optimize
		this.initialValue && this.initialValue.refresh();
	},

	choiceChanged: function (index, value) {
		this.choiceDisplay && this.choiceDisplay.children(':not(.blank)').eq(index).replaceWith(this.renderChoice(value, index + 1));

		// could optimize
		this.initialValue && this.initialValue.refresh();
	},

	choiceRemoved: function (index) {
		this.choiceDisplay && this.choiceDisplay.children(':not(.blank)').eq(index).remove();

		if (this.appearance && this.appearance.get() === 'combo') {
			this.choiceDisplay.attr('size', Math.min(this.maxPerCombo, this.choices.value.length));
		}

		// could optimize
		this.initialValue && this.initialValue.refresh();
	},

	choicesArranged: function (oldIndex, newIndex){
		if (newIndex == 0){
			$('ul.choices', this.element)
				.prepend($('ul.choices li.choice', this.element)
					.eq(oldIndex));
		}
		else {
			$('ul.choices li.choice', this.element)
				.eq(newIndex)
				.after($('ul.choices li.choice', this.element)
					.eq(oldIndex));
		}
		this.refreshChoices();
	},

	showOptions: function ($super, options) {
		$super(options);

		var that = this;
		var choices = this.choices.render();
		var otherButton = false;

		if (this.hasOther) {
			otherButton = $('<a/>', {
				href: '#',
				'class': 'btn btn-secondary btn-sm add',
				text: gettext('Add Other Choice'),
				click: function (e) {
					e.preventDefault();
					that.choices._add({ label: gettext('Other, please specify...'), other: true, static: true });
					return false;
				}
			}).appendTo(choices);

			choices.bind('extraction', function (e, enabled) {
				otherButton.toggle(enabled);
			});
			if (this.choices.extraction.question.get()) {
				otherButton.toggle(false);
			}
		}

		options.append(
			Option.renderGroup(gettext('Choices'), [choices], true),
			Option.renderGroup(gettext('Display'), [this.appearance, this.columns, this.displayInline, this.appendToPrevious, this.widthOption], true),
			Option.renderGroup(gettext('Options'), [this.optional, this.randomize, this.alphabetize, this.initialValue, this.blankChoice, this.restrictions, this.show_range], true));
	},

	renderChoice: function (item, index) {
		if (this.displayAsCombo || (this.appearance && this.appearance.get() === 'combo')) {
			return '<option>' + item.text.get() + '<\/option>';
		} else if (this.inputType == 'checkbox') {
			return '<li class="choice"><label class="custom-control custom-checkbox">\
				<input name="'+this.id+'"type="checkbox" class="custom-control-input ">\
				<span class="custom-control-indicator"></span>\
				<span class="custom-control-description">\
				<label for="'+this.id+'">'+
					item.text.get()+((item.other && item.other.value) ? '<input type="text" class="text dummy"><\/input>' : '')+
				'</label></span>\
				</label></li>'
		} else if (this.appearance.get() === undefined || this.appearance.get() === 'default' || this.appearance.get() === 'horizontal') {
			var score = l.get(item, 'score.value', null);
			if (score == null) {
				score = index;
			}

			return '<li class="choice"><label class="custom-control custom-radio">\
				<input name="'+this.id+'" type="radio" class="custom-control-input ">\
				<span class="custom-control-indicator"></span>\
				<span class="custom-control-description">\
				<label for="'+this.id+'">' + _.unescape(item.text.get())+((item.other && item.other.value) ? '<input type="text" class="text dummy"><\/input>' : '') +
				' <small class="sma-score-value">(' + gettext('Score') + ': ' + score + ')</small>' +
				'</label></span></label></li>';
		} else {
			return '<li class="choice"><label><input type="' +
				this.inputType +
				'" name="' +
				this.id +
				'" /> <span class="choice-value">' +
				item.text.get() +
				'<\/span>' +
				((item.other && item.other.value) ? '<input type="text" class="text dummy"><\/input>' : '') +
				' <small class="sma-score-value">(' + gettext('Score') + ': ' + l.get(item, 'score.value', 0) + ')</small>' +
				'<\/label><\/li>';
		}
	},

	renderChoices: function () {
		let maxScore = 0;
		let numNone = 0;
		for (var i = 0; i < this.choices.value.length; i++) {
			this.choiceDisplay.append(this.renderChoice(this.choices.value[i], i+1));

			if (this.choices.value[i].score.value !== undefined && this.choices.value[i].score.value != '') {
				if (this.choices.value[i].score.value > maxScore) {
					maxScore = this.choices.value[i].score.value;
				}
			} else {
				numNone++;
			}
		}

		if (numNone == this.choices.value.length) {
			maxScore = this.choices.value.length;
		}

		let extra = [];

		if (this.displayAsCombo || (this.appearance && this.appearance.get() === 'combo') && maxScore > 0) {
			extra.push($('<small class="sma-score-value"> (' + gettext('Score out of') + ' ' + maxScore + ')</small>'));
		}

		return extra;
	},

	getChoiceContainer: function () {
		if (this.displayAsCombo || (this.appearance && this.appearance.get() === 'combo')) {
			return $('<select/>', {
				'class': 'choices custom-select',
				multiple: this.multiSelect,
				size: (!this.displayAsCombo) ? Math.min(this.maxPerCombo, this.choices.value.length) : undefined
			});
		} else {
			return $('<ul/>', {
				'class': 'choices' + ((this.appearance.get() === 'horizontal') ? ' horizontal' : '')
			});
		}
	},

	renderContent: function () {
		var old = this.choiceDisplay;
		var oldExtra = this.extraDisplay;

		this.choiceDisplay = this.getChoiceContainer();

		this.extraDisplay = this.renderChoices();

		if (old) {
			old.remove();
		}
		if (oldExtra) {
			for (let el of oldExtra) {
				el.remove();
			}
		}

		this.element.append(this.choiceDisplay).append(this.extraDisplay);
	},

	serialize: function ($super) {
		var ca = this.appearance && this.appearance.get();

		var child = $.extend({}, {
			choices: [],
			required: !this.optional.value,
			branch: [],
			randomize: this.randomize.get() || undefined,
			alphabetize: this.alphabetize.get() || undefined,
			extraction: this.choices.extraction.question.get() && this.choices.extraction.serialize() || undefined,
			columns: this.columns && this.columns.get() > 1 && this.columns.get() || undefined,
			choiceAppearance: ca !== 'default' && ca !== 'vertical' && ca || undefined,
			initialValue: this.initialValue && this.initialValue.value
		});

		for (var i = 0; i < this.choices.length(); i++) {
			var el = this.choices.value[i];
			child.choices.push($.extend({}, {
				label: el.text.value,
				score: el.score.value,
				static : this.hasStatic && el.static.value || undefined,
				other: this.hasOther && el.other.value || undefined,
				other_required: this.hasOther && el.other_required.value || undefined,
				validation: this.hasOther && el.other.value && el.validation.value && el.validation.value.type && el.validation.value.type !== 'none' && el.validation.get() || undefined,
				na: this.hasNA && el.na.value || undefined,
				check_all: this.hasCheckAll && el.check_all.value || undefined
			}));

			if (this.hasChoiceBranching) {
				var page = el.branching.getPage();
				if (page !== undefined) {
					child.branch.push({ val: i, page: page });
				}
			}
		}

		if (!child.branch.length) {
			//sometimes this throws an illegal access error, but never does if you wrap it. no idea why not
			try {
				delete child.branch;
			}
			catch (ex) {
				console.log(ex);
			}
		}

		return $.extend($super(), {
			children: [child]
		});
	},

	refreshChoices: function (){}
});

Fields.SingleChoiceField = $.klass(Fields.ChoiceField, {
	type: 'single-choice',
	qlass: 'single-choice',
	cssType: 'single-choice',

	displayName: gettext('Multiple Choice'),
	extractable: false,
	hasChoiceChildren: true,
	hasChoiceBranching: false,

	isBranchable: true,

	isScorable: true,

	options: $.extend({}, Fields.ChoiceField.prototype.options, {
		appearance: Class.create(Fields.ChoiceField.prototype.options.appearance, {
			choices: [
				['default', gettext('Default')],
				['horizontal', gettext('Horizontal')],
				['star', gettext('Star Rating')],
				['slider', gettext('Slide Bar')],
				['combo', gettext('Combo box')]
			],
			changed: function ($super) {
				$super();
				this.field.showOptions($('#survey-editor-field-options'));
			}
		})
	}),

	getChoiceContainer: function ($super) {
		try {
			if (this.appearance.get() === 'star') {
				return $super().addClass('star clearfix').append('<li class="blank"><\/li>');
			}
			else if (this.appearance.get() === 'slider') {
				return $super().append($('<div\/>').slider({'min': 0, 'max': this.choices.value.length-1}));
			}
			else {
				return $super();
			}
		}
		catch(e) {
			return $super();
		}
	},

	renderChoices: function ($super) {

		if (this.appearance.get() === 'slider') {

			var choices = [];
			var value = this.choices.value;

			for (var i = 0; i < value.length; i++) {
				choices.push([i, value[i].text.get()]);
			}
			var cell_width = 100/choices.length
			var table = $("<table\/>", {'width': '100%'}).append("<tr\/>");
			$.each(choices, function (i, choice) {
				var new_cell = $("<td\/>", {'width': cell_width+'%', 'display':'inline'}).html(choice[1]);
				$("tr", table).append(new_cell);
			});

			return this.choiceDisplay.prepend(table);
		}
		else
		{
			return $super();
		}

	},

	choiceAdded: function ($super, item) {
		if (this.appearance.get() === 'slider') {
			this.renderContent();
		}
		else
		{
			$super(item);
		}
	},

	choiceChanged: function ($super, index, value) {
		if (this.appearance.get() === 'slider') {
			this.renderContent();
		}
		else
		{
			$super(index, value);
		}
	},

	choiceRemoved: function ($super, index) {
		if (this.appearance.get() === 'slider') {
			this.renderContent();
		}
		else
		{
			$super(index);
		}
	},

	choicesArranged: function ($super, oldIndex, newIndex){
		if (this.appearance.get() === 'slider') {
			this.renderContent();
		}
		else
		{
			$super(oldIndex, newIndex);
		}
	},

	showOptions: function($super, options) {
		if(this.appearance.value == 'slider')
		{

			Fields.Field.prototype.showOptions.call(this, options);

			var that = this;
			var choices = this.choices.render();
			var otherButton = false;

			if (this.hasOther) {
				otherButton = $('<a/>', {
					href: '#',
					'class': 'btn btn-secondary btn-sm add',
					text: gettext('Add Other Choice'),
					click: function (e) {
						e.preventDefault();
						that.choices._add({ label: gettext('Other, please specify...'), other: true, static: true });
						return false;
					}
				}).appendTo(choices);

				choices.bind('extraction', function (e, enabled) {
					otherButton.toggle(enabled);
				});
				if (this.choices.extraction.question.get()) {
					otherButton.toggle(false);
				}
			}

			options.append(
				Option.renderGroup(gettext('Choices'), [choices], false),
				Option.renderGroup(gettext('Display'), [this.appearance, this.displayInline, this.appendToPrevious, this.widthOption], true),
				Option.renderGroup(gettext('Options'), [this.optional, this.initialValue], true));
		}
		else
		{
			$super(options);
		}
	},

	serialize: function ($super) {
		var info = $super();

		return $.extend(info, {
			children: [$.extend(info.children[0], {
				type: 'single'
			})]
		});
	}
});

Fields.DropDownChoiceField = $.klass(Fields.ChoiceField, {
	type: 'dropdown-choice',
	qlass: 'dropdown-choice',
	cssType: 'dropdown-choice',

	displayName: gettext('Dropdown'),

	hasOther: false,
	hasChoiceBranching: false,
	isBranchable: true,
	extractable: false,
	displayAsCombo: true,

	options: $.extend({}, Fields.ChoiceField.prototype.options, {
		blankChoice: Class.create(chide.opts.Text, {
			label: gettext('Blank choice'),
			help: gettext('Blank choice - The initial value displayed, indicating that a selection has not been made. (This will not count towards a response if selected)'),
			inputClass: 'text short',
			changed: function (value) {
				this.field.choiceDisplay.children().eq(0).text(this.get());
				},
			get: function ($super) { return (this.value) ? $super() : '---'; }
		}),
		appearance: false,
		columns: false
	}),

	initialize: function ($super, info, editor) {
		$super(info = info || {}, editor);

		this.blankChoice = new this.options.blankChoice({ field: this, value: info.children && info.children[0] && info.children[0].blank_choice || info.blankChoice || undefined })
	},

	getChoiceContainer: function ($super) {
		return $super().append($('<option class="blank"/>').text(this.blankChoice.get()));
	},

	serialize: function ($super) {
		var info = $super();

		return $.extend(info, {
			children: [$.extend(info.children[0], {
				type: 'dropdown',
				blank_choice: this.blankChoice.get() && this.blankChoice.value
			})]
		});
	}
});

Fields.MultipleChoiceField = $.klass(Fields.ChoiceField, {
	type: 'multiple-choice',
	qlass: 'multiple-choice',
	cssType: 'multiple-choice',

	displayName: gettext('Checkbox'),
	inputType: 'checkbox',

	extractable: true,
	isBranchable: true,
	multiSelect: true,

	hasCheckAll: true,
	hasNA: true,

	supportedActions: Fields.Field.prototype.supportedActions.concat([
		Fields.Actions.looping
	]),

	options: $.extend({}, Fields.ChoiceField.prototype.options, {
		initialValue: false
	}),

	initialize: function ($super, info, editor) {
		var that = this;

		$super(info, editor);

		info = info || {};

		var restrictions = undefined;
		var errorMsg = undefined;

		if (info.children && info.children[0] && info.children[0].restrictions) {
			restrictions = [info.children[0].restrictions.minChecked, info.children[0].restrictions.maxChecked];

			if (restrictions[0] === undefined && restrictions[1] === undefined) {
				restrictions = undefined;
			}
		}

		if (info.children && info.children[0] && info.children[0].err_msg) {
			errorMsg = info.children[0].err_msg;
		}

		this.restrictions = new Validation.Restriction({ field: this, value: restrictions, errorMsg: errorMsg });

		this.show_range = new this.options.show_range({ field:this, value: (info.children && info.children[0]) ? !!info.children[0].show_range : !!info.show_range });

	},

	getVariables: function () {
		return [new Variable.Multi({
			id: this.id,
			label: this.getIdentifier(),
			choices: (this.choices) ? $.map(this.choices.value, function (el){return el.text.get();}):undefined
		})];
	},

	getExtractionChoices: function () {
		var result = [];
		$.each(this.choices.value, function (i, val) {
			result.push([i, val.text.value]);
		});
		return result;
	},

	getExtractionOptions: function (config) {
		return new chide.opts.Checkbox({
			label: gettext('Inverted extraction'),
			value: config && config.inverted
		});
	},

	serializeExtractionOptions: function (options) {
		return {
			inverted: !!(options && options.value)
		};
	},

	serialize: function ($super) {
		var info = $super();

		var loops = this.survey.looping.loops;

		return $.extend(info, {
			children: [$.extend(info.children[0], {
				type: 'multiple',
				restrictions: this.restrictions && this.restrictions.serialize() || undefined,
				show_range: this.show_range.get() || undefined,
				err_msg: this.restrictions && this.restrictions.errorMsg.get() && this.restrictions.errorMsg.value || undefined
			})]
		});
	}
});

Fields.GridField = $.klass(Fields.Field, {
	type: 'grid',
	qlass: 'grid',
	cssType: 'grid',

	displayName: gettext('Grid Field'),

	baseType: undefined,

	isGrouped: true,
	questionSize: 30,

	options: $.extend({}, Fields.Field.prototype.options, {
		randomize: Class.create(chide.opts.Checkbox, {
			label: gettext('Randomize Variables'),
			help: gettext('Randomize Variables - Check this option if you would like this question\'s rows to be shown in a random order every time the page is viewed.'),
			changed: function (value) { if (value) { this.field.alphabetize && this.field.alphabetize.set(false).refresh(); } }
		}),

		alphabetize: Class.create(chide.opts.Checkbox, {
			label: gettext('Alphabetize Variables'),
			help: gettext('Alphabetize Variables - Check this option if you would like this question\'s rows to be shown in alphabetical order.'),
			changed: function (value) { if (value) { this.field.randomize && this.field.randomize.set(false).refresh(); } }
		}),

		unique: Class.create(chide.opts.Checkbox, {
			label: gettext('Force Unique Responses')
		}),

		staticcol: Class.create(chide.opts.Checkbox, {
			label: gettext('Make First Column Static'),
			help: gettext('Make First Column Static - Check this option if you would like this question\'s row titles to always be visible on the left hand side during column scrolling.')
		}),

		showBorders: Class.create(chide.opts.Checkbox, {
			label: gettext('Show Borders'),
			help: gettext("Show Borders - Show borders separating the rows and columns of this question (Makes complex 3D matrices easier to understand)")
		}),

		alternateBackground: Class.create(chide.opts.Checkbox, {
			label: gettext('Alternate Background Color'),
			help: gettext("Alternate Background Colors - Each column in the matrix will have an alternating background color making it stand out from the previous column and easier to understand.")
		}),

		firstColSize: Class.create(chide.opts.Single, {
			help: gettext("1st Column Size - This option allows you to modify the space reserved for variables and choices in real time."),
			label: gettext("1st Column Size: "),
			optionClass: 'opt clearfix',
			choices: [
				[10, '10%'],
				[20, '20%'],
				[30, '30%'],
				[40, '40%'],
				[50, '50%'],
				[60, '60%'],
				[70, '70%'],
				[80, '80%'],
				[90, '90%']
			],
			changed: function (value) { this.field.renderContent(); }
		}),

		variableList: Class.create(chide.opts.TextList, {
			hasSubOptions: true,

			itemFromValue: function (value) {
				return {
					text: new this.textClass({ value: (value && value.label) ? value.label : '' }),
					optional: new this.field.options.optional({ info: value })
				};
			},

			renderSubOptions: function ($super, item, index) {
				var superF= $super(item, index)
				if (!(this.field instanceof Fields.RankingField))
					superF.append(item.optional.render());
				return superF;
			},

			itemAdded: function (item) { this.field.variableAdded(item); },
			itemChanged: function (index, value) { this.field.variableChanged(index, value); },
			itemRemoved: function (index) { this.field.variableRemoved(index); },
			itemsChanged: function (value) { this.field.renderContent(); }
		})
	}),

	initialize: function ($super, info, editor) {
		var that = this;

		$super(info, editor);

		info = info || {};

		var variables;

		if (info.children && info.children.length) {
			variables = info.children;
		} else {
			variables = this.getDefaultVariables();
		}

		this.uniqueError = new chide.opts.Text({
			displayInline: false,
			labelClass: '',
			label: gettext('Error Message for Unique Responses.'),
			value: (info && info.uniqueError) || gettext('Responses must be unique'),
			help: gettext('Unique Responses - The label that will show beneath the question informing the user of the restraint.')
		});

		this.randomize = new this.options.randomize({ field:this, value: !!info.randomize });

		this.alphabetize = new this.options.alphabetize({ field:this, value: !!info.alphabetize });

		this.unique = new this.options.unique({ value: !!info.unique });

		if (this.options.staticcol) {
			this.staticcol = new this.options.staticcol({
				value: !!info.staticcol
			});
		}

		this.firstColSize = new this.options.firstColSize({ field: this, value: info.questionSize || this.questionSize || 30 });

		this.variables = new this.options.variableList({ field: this, value: variables, extraction: info.extraction || undefined });

		this.showBorders = new this.options.showBorders({ value: !!info.showBorders });

		this.alternateBackground = new this.options.alternateBackground({ value: !!info.alternateBackground });
	},

	getDefaultVariables: function () {
		return [{
			label: gettext('Variable 1')
		}, {
			label: gettext('Variable 2')
		}];
	},

	getVariables: function () {
		var that = this;

		return $.map(this.variables.value, function (el, i) {
			var choices = (el.choices) ? el.choices : that.choices;
			return new that.baseType($.extend({},{
				id: that.id + '_' + i,
				label: (that.name.get()) ? '[' + that.name.get() + '.' + i + '] ' + el.text.get() : el.text.get(),
				choices: (choices) ? $.map(choices.value, function (el){return el.text.get();}):undefined
			}));
		});
	},

	variableAdded: function (value) {
		var row = $('<tr><td style="width:' + this.firstColSize.get() + '%"><label><span class="variable"><\/span><\/label><\/td><td class="input"><\/td><\/tr>').appendTo(this.tableDisplay);

		if (value) {
			$('span.variable', row).html(value.text.get());
			$('td.input', row).append(value.input = this.getInput(value));
		}

		return row;
	},

	variableChanged: function (index, value) {
		$('span.variable', this.tableDisplay).eq(index).html(value.text.get());
	},

	variableRemoved: function (index) {
		$('tr', this.tableDisplay).eq(index).remove();
	},

	variablesCleared: function () {
		$('tr', this.tableDisplay).remove();
	},

	serialize: function () {
		var children = [];

		for (var i = 0; i < this.variables.length(); i++) {
			children.push(this.serializeVariable(i, this.variables.value[i]));
		}
		return $.extend(Fields.Field.prototype.serialize.call(this), {
			grouped: true,
			randomize: this.randomize.get() || false,
			alphabetize: this.alphabetize.get() || false,
			questionSize: this.firstColSize.get() || 30,
			unique: this.unique.get() || false,
			uniqueError: this.uniqueError.get() || gettext('These answers must be unique'),
			staticcol: ((this['staticcol']) ? this.staticcol.get() : false) || false,
			showBorders: this.showBorders.get() || false,
			alternateBackground: this.alternateBackground.get() || false,
			extraction: this.variables.extraction.serialize(),
			children: children
		});
	},

	renderContent: function () {
		var old = this.tableDisplay;
		var table = (this.tableDisplay = $('<table class="variables"></table>'));

		if (old) {
			old.remove();
		}

		table.appendTo(this.element);
	},

	serializeVariable: function (i, info) { }
});

Fields.TextGridField = $.klass(Fields.GridField, {
	type: 'text-response-grid',
	qlass: 'text-response-grid',
	cssType: 'text-response-grid',
	extractable: true,
 	isBranchable: true,
	displayName: gettext('Text Response Grid'),
	questionSize: 20,
	isVisible: false,

	baseType: Variable.String,

	supportedActions: Fields.GridField.prototype.supportedActions.concat([
		Fields.Actions.looping
	]),

	options: $.extend({}, Fields.GridField.prototype.options, {
		variableList: Class.create(Fields.GridField.prototype.options.variableList, {
			options: Fields.TextField.prototype.options,

			itemFromValue: function ($super, value) {
				var that = this;

				var item = $super(value);

				return $.extend(item, {
					appearance: new this.options.appearance({ field: item, value: value && value.appearance === 'full' }),
					rows: new this.options.rows({ field: item, value: value && value.rows || undefined }),
					cols: new this.options.cols({ field: item, value: value && value.cols || undefined }),
					initialValue: new this.options.initialValue({ field: item, value: value && value.initialValue || undefined }),
					restore_default: new this.options.restore_default({ field: item, value: value && value.restore_default || undefined }),
					validation: new Validation(this.field, { value: value && value.validation || undefined }),
					renderContent: function () {
						item.input.replaceWith(item.input = that.field.getInput(item));
					}
				});
			},

			renderSubOptions: function ($super, item, index) {
				return $super(item, index).append(
					item.appearance.render(item),
					Option.renderGroup(gettext('Additional Options'), [item.validation, item.initialValue, item.restore_default], true));
			}
		})
	}),

	initialize: function ($super, info, editor) {
		$super(info, editor);
		this.sum = new chide.opts.Text({
			displayInline: true,
			allowBlank: true,
			inputClass: 'text inline medium',
			label: gettext('Sum'),
			value: (info && info.sum) || undefined,
			help: gettext("About Sum - Sum validates that all answers given add up to a certain value. (Enter '-' to show, but not validate, the sum.)")
		});

		this.sum.set = function (value) {
			this.value = value;
		};

		this.sum_label = new chide.opts.Text({
			displayInline: false,
			labelClass: '',
			label: gettext('Sum Label ({x} - Total, {y} - Current)'),
			value: (info && info.sum_label) || gettext('The values should add up to {x}. Currently: {y}'),
			help: gettext('Sum Label - The label that will show beneath the question informing the user of the restraint. Place {x} or {y} in your text and they will be replaced with their appropriate values. Leave blank to show nothing.')
		});

		this.variables_panel = new Option.Collapsable({
			label: gettext('Variables')
		});

		this.options_panel = new Option.Collapsable({
			collapsed: true,
			label: gettext('Options')
		});

		this.display_panel = new Option.Collapsable({
			label: gettext('Display'),
			collapsed: true
		});
	},

	getInput: function (value) {
		return Fields.TextField.prototype.getInput.call(value);
	},

	renderContent: function () {
		var that = this;
		var old = this.tableDisplay;
		var table = (this.tableDisplay = $('<table class="variables"></table>'));
		var value = this.variables.value;

		for (var i = 0; i < this.variables.length(); i++) {
			this.variableAdded();
		}

		$('span.variable', table).text(function (i) { return value[i].text.get(); });
		$('td.input', table).append(function (i) { return (value[i].input = that.getInput(value[i])); });

		if (old) {
			old.remove();
		}

		table.appendTo(this.element);
	},

	showOptions: function ($super, options) {
		var that = this;

		$super(options);

		options
			.append(this.variables_panel.render([this.variables.render()]))
			.append(this.display_panel.render([this.firstColSize.render(), this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render()]))
			.append(this.options_panel.render([this.randomize.render(), this.alphabetize.render(), this.unique.render(), this.uniqueError.render(), this.sum.render(), this.sum_label.render()]));
	},

	serializeVariable: function (i, info) {
		return $.extend({}, {
			type: 'string',
			label: info.text.get() && info.text.value,
			required: !info.optional.value,
			validation: info.validation.value && info.validation.value.type && info.validation.value.type !== 'none' && info.validation.get() || undefined,
			initialValue: info.initialValue.get() && info.initialValue.value || undefined,
			restore_default: info.restore_default.get() && info.restore_default.value || undefined,
			appearance: info.appearance.get() && 'full' || undefined,
			rows: info.rows.value || undefined,
			cols: info.cols.value || undefined
		});
	},

	getExtractionChoices: function () {
		var that = this;

		if (this.variables.extraction.question.get()) {
			return this.variables.extraction.question.getField().getExtractionChoices();
		}

		return $.map(this.variables.value, function (val, i) {
			return [[i, val.text.value]];
		});
	},

	getExtractionOptions: function (config) {
		return new chide.opts.Checkbox({
			label: gettext('Extract only unique responses'),
			value: config && config.unique
		});
	},

	serializeExtractionOptions: function (options) {
		return {
			unique: (options && options.value) ? options.value : false
		};
	},

	serialize: function ($super) {
		var info = $super();

		if (!isNaN(this.sum.get()) || this.sum.get() == "-" || (typeof(this.sum.get()) === 'string' && this.sum.get().match(/{{.*}}/)) ){
			info.sum = this.sum.get();
		}

		info.sum_label = this.sum_label.value;

		return info;
	}
});

Fields.ChoiceGridField = $.klass(Fields.GridField, {
	type: 'choice-grid',
	qlass: 'choice-grid',
	cssType: 'choice-grid',

	displayName: gettext('Choice Grid'),

	baseType: Variable.Single,

	isGrouped: true,
	hasOther: false,
	hasChoiceChildren: true,

	options: $.extend({}, Fields.GridField.prototype.options, {
		choiceList: Class.create(Fields.ChoiceField.prototype.options.choiceList, {
			direction:'horizontal',
			tabOffset: 10000
		})
	}),

	initialize: function ($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		var choices;

		if (info.children && info.children[0] && info.children[0].choices) {
			choices = info.children[0].choices;
		} else if (info.choices) {
			choices = info.choices;
		} else {
			choices = this.getDefaultChoices();
		}

		this.choices = new this.options.choiceList({ field: this, value: choices, extraction: info.choice_extraction });

		this.choices_panel = new Option.Collapsable({
			label: gettext('Choices'),
			collapsed: false
		});
		this.variables_panel = new Option.Collapsable({
			label: gettext('Variables'),
			collapsed: false
		});
		this.options_panel = new Option.Collapsable({
			label: gettext('Options'),
			collapsed: true,
			id: 'options'
		});
		this.display_panel = new Option.Collapsable({
			label: gettext('Display'),
			collapsed: true,
			id: 'display'
		});
	},

	getDefaultChoices: function () {
		return [{
			label: gettext('Choice 1')
		}, {
			label: gettext('Choice 2')
		}];
	},

	choiceAdded: function (value) {
		var that = this;
		var len = $('span.choice', this.tableHeader).length;

		var choice = $('<td><span class="choice"></span></td>');

		if (len) {
			choice.insertAfter($('td', this.tableHeader).eq(len));
		} else {
			choice.appendTo(this.tableHeader);
		}

		if (value) {
			$('span.choice', choice).html(value.text.get());
		}

		$('tbody tr', this.tableDisplay).each(function (i) {
			var cell = $('<td><input type="radio" name="' + that.id + '_' + i + '"></td>');

			if (len) {
				cell.insertAfter($('td', this).eq(len));
			} else {
				cell.appendTo(this);
			}
		});
	},

	choiceChanged: function (index, value) {
		$('span.choice', this.tableHeader).eq(index).html(value.text.get());
	},

	choiceRemoved: function (index) {
		$('td:nth-child(' + (index + 2) + ')', this.tableDisplay).remove();
	},

	variableAdded: function (value) {
		var row = '<tr><td style="width:' + this.firstColSize.get() + '%"><span class="variable"></span><\/td>';
		var index = this.variables.length();

		for (var j = 0; j < this.choices.value.length; j++) {
			row += '<td><input type="radio" name="' + this.id + '_' + index + '"></td>';
		}

		row = $(row + '<\/tr>');

		if (value) {
			$('span.variable', row).html(value.text.get());
		}

		return row.appendTo($('tbody', this.tableDisplay));
	},

	variableChanged: function (index, value) {
		$('tbody span.variable', this.tableDisplay).eq(index).html(value.text.get());
	},

	variableRemoved: function (index) {
		$('tbody tr', this.tableDisplay).eq(index).remove();
	},

	variablesCleared: function () {
		$('tbody tr', this.tableDisplay).remove();
	},

	renderContent: function () {
		var that = this;
		var old = this.tableDisplay;
		var table = (this.tableDisplay = $('<table class="variables"></table>'));

		this.tableHeader = $('<thead><tr><td style="width:' + this.firstColSize.get() + '%"></td></tr></thead>').appendTo(table).find('tr');

		table.append('<tbody><\/tbody>');

		for (var j = 0; j < this.choices.length(); j++) {
			this.choiceAdded();
		}

		for (var j = 0; j < this.variables.length(); j++) {
			this.variableAdded(this.variables.value[j]);
		}

		$('span.choice', table).html(function (i) { return that.choices.value[i].text.get(); });

		if (old) {
			old.remove();
		}
		table.appendTo(this.element);
	},

	showOptions: function ($super, options) {
		Fields.Field.prototype.showOptions.call(this, options);

		options
			.append(this.choices_panel.render([this.choices.render()]))
			.append(this.variables_panel.render([this.variables.render()]))
			.append(this.display_panel.render([
				((this.staticcol) ? this.staticcol.render() : undefined),
				this.firstColSize.render(),
				this.displayInline.render(),
				this.appendToPrevious.render(),
				this.widthOption.render(),
				this.showBorders.render(),
				this.alternateBackground.render()
			]))
			.append(this.options_panel.render([this.randomize.render(), this.alphabetize.render(), this.unique.render()]));
	},

	serialize: function ($super) {
		var info = $super();

		if (this.choices.extraction.question.get()) {
			info.choice_extraction = this.choices.extraction.serialize();
		}

		info.choices = [];

		for (var i = 0; i < this.choices.length(); i++) {
			info.choices.push($.extend({}, {
				label: this.choices.value[i].text.value,
				score: this.choices.value[i].score.value
			}));
		}

		return info;
	},

	serializeVariable: function (i, info) {
		return {
			type: 'single',
			label: info.text.value,
			required: !info.optional.value
		};
	}
});

Fields.SingleChoiceGridField = $.klass(Fields.ChoiceGridField, {
	type: 'single-choice-grid',
	qlass: 'single-choice-grid',
	cssType: 'single-choice-grid',

	displayName: gettext('Rating Scale'),
	isBranchable: true,

	extractable: true,

	supportedActions: Fields.ChoiceGridField.prototype.supportedActions.concat([
		Fields.Actions.looping
	]),

	getDefaultVariables: function () {
		return [{
			label: gettext('Row 1')
		}];
	},

	getDefaultChoices: function () {
		return [{
			label: gettext('Choice 1')
		}, {
			label: gettext('Choice 2')
		}, {
			label: gettext('Choice 3')
		}, {
			label: gettext('Choice 4')
		}];
	},

	getExtractionChoices: function () {
		var that = this;

		if (this.variables.extraction.question.get()) {
			return this.variables.extraction.question.getField().getExtractionChoices();
		}

		return $.map(this.variables.value, function (val, i) {
			return [[i, val.text.get()]];
		});
	},

	getExtractionOptions: function (config) {
		var choices;

		if (this.choices.extraction.question.get()) {
			choices = this.choices.extraction.question.getField().getExtractionChoices();
		} else {
			choices = $.map(this.choices.value, function (val, i) {
				return [[i, val.text.get()]];
			});
		}

		choices.push([-1,'No Choice'])

		var selectAll = $.map(choices, function (val, i) {
			return [i];
		});

		return new ($.klass(Option.Multiple, {
			render: function ($super) {
				return $super()
					.prepend(this.label);
			}
		}))(this, {
			label: gettext('Choices which should trigger extraction:'),
			value: (config) ? config.choices : selectAll,
			choices: choices
		});
	},

	serializeExtractionOptions: function (options) {
		return {
			choices: (options) ? $.map(options.value, function (i) { return parseInt(i, 10); }) : []
		};
	}
});

Fields.DropDownGridField = $.klass(Fields.ChoiceGridField, {
	type: 'dropdown-grid',
	qlass: 'dropdown-grid',
	cssType: 'dropdown-grid',

	displayName: gettext('Dropdown Grid'),

	isGrouped: true,
	isBranchable: true,
	isVisible: false,

	extractable: true,

	supportedActions: Fields.ChoiceGridField.prototype.supportedActions.concat([
		Fields.Actions.looping
	]),

	options: $.extend({}, Fields.ChoiceGridField.prototype.options, {
		variableList: Class.create(Fields.ChoiceGridField.prototype.options.variableList, {
			options: Fields.ChoiceField.prototype.options,

			itemFromValue: function ($super, value) {
				var that = this;

				var item = $super(value);

				return $.extend(item,{
					randomize: new this.options.randomize({ field:item, value: value && value.randomize || false}),
					alphabetize: new this.options.alphabetize({ field:item, value: value && value.alphabetize || false})
				});
			},


			renderSubOptions: function ($super, item, index) {
				return $super(item, index).append(
					item.alphabetize.render(),
					item.randomize.render());
			}
		})
	}),

	initialize: function ($super, info, editor) {
		info = info || {};

		$super(info, editor);

		var that = this;

		this.blankChoice = new Fields.DropDownChoiceField.prototype.options.blankChoice({
			field: this,
			value: info.children && info.children[0] && info.children[0].blank_choice || info.blankChoice || undefined,
			changed: function (value) {
					$('select.choices option.blank', that.tableDisplay).text(value);
				}
		 });
	},

	showOptions: function ($super, options) {
		Fields.Field.prototype.showOptions.call(this, options);

		options
			.append(this.choices_panel.render([this.choices.render()]))
			.append(this.variables_panel.render([this.variables.render()]))
			.append(this.display_panel.render([this.firstColSize.render(), this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render()])
			.append(this.options_panel.render([this.randomize.render(), this.alphabetize.render(), this.unique.render(), this.uniqueError.render(), this.blankChoice.render()])));
	},

	choiceAdded: function (value) {
		$('select.choices', this.tableDisplay).append($('<option><\/option>')
			.text(value.text.get()));
	},

	choiceChanged: function (index, value) {
		$('select.choices option:nth-child(' + (index + 2) + ')', this.tableDisplay).text(value.text.get());
	},

	choiceRemoved: function (index) {
		$('select.choices option:nth-child(' + (index + 2) + ')', this.tableDisplay).remove();
	},

	variableAdded: function (value, input) {
		var row = $('<tr><td style="width:' + this.firstColSize.get() + '%"><span class="variable"><\/span><\/td><td class="input"><\/td><\/tr>');

		if (value) {
			$('span.variable', row).html(value.text.get());
		}

		$('td.input', row).append(this.getInput());

		return row.appendTo(this.tableDisplay);
	},

	getInput: function () {
		var choices = $('<select class="choices custom-select"/>');

		choices.append('<option class="blank">' + this.blankChoice.get() + '</option>');

		for (var i = 0; i < this.choices.length(); i++) {
			choices.append('<option>' + this.choices.getAt(i) + '</option>');
		}

		return choices;
	},

	renderContent: function () {
		var old = this.tableDisplay;
		var table = (this.tableDisplay = $('<table class="variables"></table>'));

		for (var i = 0; i < this.variables.length(); i++) {
			this.variableAdded(this.variables.value[i]);
		}

		if (old) {
			old.remove();
		}

		table.appendTo(this.element);
	},

	serializeVariable: function (i, info) {
		return $.extend({}, {
			type: 'dropdown',
			label: info.text.value,
			required: !info.optional.value,
			blank_choice: this.blankChoice.value,
			randomize: info.randomize.value || false,
			alphabetize: info.alphabetize.value || false
		});
	},

	getExtractionChoices: function () {
		var that = this;

		if (this.variables.extraction.question.get()) {
			return this.variables.extraction.question.getField().getExtractionChoices();
		}

		return $.map(this.variables.value, function (val, i) {
			return [[i, val.text.get()]];
		});
	},

	getExtractionOptions: function (config) {
		var choices;

		if (this.choices.extraction.question.get()) {
			choices = this.choices.extraction.question.getField().getExtractionChoices();
		} else {
			choices = $.map(this.choices.value, function (val, i) {
				return [[i, val.text.get()]];
			});
		}
		choices.push([-1,'No Choice'])
		return new ($.klass(Option.Multiple, {
			render: function ($super) {
				return $super()
					.prepend(this.label);
			}
		}))(this, {
			label: gettext('Choices which should trigger extraction:'),
			value: (config) ? config.choices : [],
			choices: choices
		});
	},

	serializeExtractionOptions: function (options) {
		return {
			choices: (options) ? $.map(options.value, function (i) { return parseInt(i, 10); }) : []
		};
	}
});

Fields.DateTimeField = $.klass(Fields.Field, {
	type: 'datetime',
	qlass: 'datetime',
	cssType: 'datetime',
	isBranchable: true,
	isQuestion: false,
	displayName: gettext('Date/Time'),

	timezones: [
		[0, '(GMT -12:00) Eniwetok, Kwajalein'],
		[1, '(GMT -11:00) Midway Island, Samoa'],
		[2, '(GMT -10:00) Hawaii'],
		[3, '(GMT -9:00) Alaska'],
		[4, '(GMT -8:00) Pacific Time (US, Canada'],
		[5, '(GMT -7:00) Mountain Time (US, Canada)'],
		[6, '(GMT -6:00) Central Time (US, Canada)'],
		[7, '(GMT -5:00) Eastern Time (US, Canada)'],
		[8, '(GMT -4:00) Atlantic Time (Canada), Caracas'],
		[9, '(GMT -3:30) Newfoundland'],
		[10, '(GMT -3:00) Brazil, Buenos Aires, Georgetown'],
		[11, '(GMT -2:00) Mid-Atlantic'],
		[12, '(GMT -1:00 hour) Azores, Cape Verde Islands'],
		[13, '(GMT) UTC, London, Lisbon, Casablanca'],
		[14, '(GMT +1:00 hour) Brussels, Madrid, Paris'],
		[15, '(GMT +2:00) Kaliningrad, South Africa'],
		[16, '(GMT +3:00) Baghdad, Riyadh, Moscow'],
		[17, '(GMT +3:30) Tehran'],
		[18, '(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi'],
		[19, '(GMT +4:30) Kabul'],
		[20, '(GMT +5:00) Ekaterinburg, Islamabad'],
		[21, '(GMT +5:30) Bombay, Calcutta, Madras'],
		[22, '(GMT +6:00) Almaty, Dhaka, Colombo'],
		[23, '(GMT +7:00) Bangkok, Hanoi, Jakarta'],
		[24, '(GMT +8:00) Beijing, Singapore, Hong Kong'],
		[25, '(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo'],
		[26, '(GMT +9:30) Adelaide, Darwin'],
		[27, '(GMT +10:00) Eastern Australia, Guam'],
		[28, '(GMT +11:00) Magadan, Solomon Islands'],
		[29, '(GMT +12:00) Auckland, Wellington, Fiji']
	],

	options: $.extend({}, Fields.Field.prototype.options, {
		dateFormat: Class.create(chide.opts.Single, {
			label: gettext('Display Format'),
			choices: [
				[0, gettext('Date/time')],
				[1, gettext('Date only')],
				[2, gettext('Time only')],
				[3, gettext('Day/Month')],
				[4, gettext('Month/Year')],
			],
			get: function () { return (this.value === undefined) ? 0 : this.value; },
			set: function (value) { this.value = (value == 0) ? undefined : value;  },
			changed: function () { this.field.renderContent(); }
		}),

		showTimezone: Class.create(chide.opts.Checkbox, {
			label: gettext('Timezone'),
			changed: function (value) { this.field.renderContent(); }
		}),

		initialValueDate: Class.create(chide.opts.Text, {
			displayInline: true,
			inputClass: 'text inline short',
			label: gettext('Initial Date'),
			help: gettext('Optional - Choose an initial value for the date.'),
			inputClass: 'text short iDate',
			changed: function (value) {
				this.field.input.val(value);
			}
		}),

		initialValueTime: Class.create(chide.opts.Text, {
			displayInline: true,
			inputClass: 'text inline short',
			label: gettext('Initial Time'),
			help: gettext('Optional - Choose an initial value for the time.'),
			inputClass: 'text short iTime',
			changed: function (value) { this.field.input.val(value); }
		}),


		giveInitialValue: Class.create(chide.opts.Checkbox, {
			label: gettext('Set to now by default'),
			changed: function (value) { this.field.renderContent(); }
		}),

		showNowButton: Class.create(chide.opts.Checkbox, {
			label: gettext('Show "Record Now" button'),
			changed: function (value) { this.field.renderContent(); this.field.showOptions($('#survey-editor-field-options'));  }
		}),

		NowButtonText: Class.create(chide.opts.Text, {
			displayInline: true,
			inputClass: 'text inline medium',
			label: gettext('Customize text'),
			labelClass: 'inline',
			changed: function (value) { this.field.renderContent(); }
		})
	}),

	initialize: function ($super, info, editor) {
		$super(info, editor);

		var that = this;

		this.optional = new this.options.optional({ info: info, changed: function (value) {that.render();}});

		this.dateFormat = new this.options.dateFormat({ field: this, value: (info && info.format !== undefined) ? info.format : (info && info.children && info.children.length && info.children[0].dateFormat !== undefined) ? info.children[0].dateFormat : '0' });

		this.initialValueDate = new this.options.initialValueDate({ field: this, value: (info && info.children && info.children[0] && info.children[0].initialValueDate || (info && info.initialValueDate)) || undefined });

		this.initialValueTime = new this.options.initialValueTime({ field: this, value: (info && info.children && info.children[0] && info.children[0].initialValueTime || (info && info.initialValueTime)) || undefined });

		this.showTimezone = new this.options.showTimezone({ field: this, value: (info && info.timezone !== undefined) ? info.timezone : (info && info.children && info.children.length && info.children[0].timezone !== undefined) ? info.children[0].timezone : false });

		this.giveInitialValue = new this.options.giveInitialValue({ field: this, value: (info && info.giveInitialValue !== undefined) ? info.giveInitialValue : (info && info.children && info.children.length && info.children[0].giveInitialValue !== undefined) ? info.children[0].giveInitialValue : false });

		this.showNowButton = new this.options.showNowButton({ field: this, value: (info && info.showNowButton !== undefined) ? info.showNowButton : (info && info.children && info.children.length && info.children[0].showNowButton !== undefined) ? info.children[0].showNowButton : false });

		this.nowButtonText = new this.options.NowButtonText({ field: this, value: (info && info.nowButtonText !== undefined) ? info.nowButtonText : (info && info.children && info.children.length && info.children[0].nowButtonText !== undefined) ? info.children[0].nowButtonText : 'Record Now' });
	},

	getVariables: function () {
		return [new Variable.DateTime({ id: this.id, label: this.getIdentifier() })];
	},

	getInput: function () {
		var mode = this.dateFormat.get();

		var result = $('<div/>');

		if (mode == 0 || mode == 1) {
			let placeholder = gettext("YYYY/MM/DD");

			if (window.DATE_FORMAT == '0') {
				placeholder = 'MM/DD/YYYY';
			}
			else if (window.DATE_FORMAT == '1') {
				placeholder = 'DD/MM/YYYY';
			}

			result.append('<input type="text" class="form-control d-inline mr-3" style="width: 9em;" value="'+placeholder+'" />');
		}

		if (mode == 3) {
			result.append('<input type="text" class="form-control d-inline mr-3" style="width: 9em;" value="MM/DD" />');
		}

		if (mode == 4) {
			result.append('<input type="text" class="form-control d-inline mr-3" style="width: 9em;" value="MM/YY" />');
		}

		if (mode == 5 || mode == 7) {
			result.append('<input type="text" class="form-control d-inline mr-3" style="width: 9em;" value="'+gettext("MM/DD/YYYY")+'" />');
		}

		if (mode == 6 || mode == 8) {
			result.append('<input type="text" class="form-control d-inline mr-3" style="width: 9em;" value="'+gettext("DD/MM/YYYY")+'" />');
		}

		if (mode == 0 || mode == 2 || mode == 5 || mode == 6) {
			result.append(
				'<input type="text" class="form-control d-inline" style="width: 4em;" value="HH" />:',
				'<input type="text" class="form-control d-inline mr-1" style="width: 4em;" value="MM" />',
				'<input type="text" class="form-control d-inline" style="width: 6em;" value="AM/PM" />');
		}

		if (this.showTimezone.get()) {
			chide.opts.renderSelect(this.timezones, '---').appendTo(result);
		}

		if (this.showNowButton.get()) {
			result.append('<a href="#" class="btn btn-default">'+this.nowButtonText.get()+'</a>');
		}

		return result;
	},

	showOptions: function ($super, options) {
		$super(options);

	options.append(Option.renderGroup(gettext('Display'), [this.displayInline, this.appendToPrevious, this.widthOption], true));
		var sub_options = [this.optional, this.dateFormat, this.showTimezone, this.giveInitialValue, this.showNowButton];

		if (this.showNowButton.get()){
			sub_options.push(this.nowButtonText);
		}

		sub_options.concat([this.initialValueDate, this.initialValueTime]);
		options.append(Option.renderGroup(gettext('Options'), sub_options, true));
		//who knows how to set the placeholder when creating the object?
		$('.iDate').attr('placeholder', 'YYYY/MM/DD');
		$('.iTime').attr('placeholder', '18:00');

	},

	renderContent: function () {
		if (this.input) {
			this.input.remove();
		}

		this.element.append(this.input = this.getInput());
	},

	serialize: function ($super) {
		var info = $super();

		info.children = [];

		info.children.push($.extend({}, {
			type: this.type,
			required: !this.optional.value,
			dateFormat: this.dateFormat.value,
			timezone: this.showTimezone.get(),
			giveInitialValue: this.giveInitialValue.get(),
			showNowButton: this.showNowButton.get(),
			nowButtonText: this.nowButtonText.value,
			initialValueDate: this.initialValueDate.get() && this.initialValueDate.value || undefined,
			initialValueTime: this.initialValueTime.get() && this.initialValueTime.value || undefined

		}));

		return info;
	}
});

Fields.Helpers = {
	useMapping: false,

	mapping: {},

	normalizeField: function (field){
		/* Perform any post load/paste actions to prepare this field for use in the editor */

		/*
		if (field.choices && field.choices.value && field.branching) {
			field.choices.value.each(function (i) {
				if (this.branching && this.branching.value == undefined) {
					for (var j = 0; j < field.branching.length; j++) {
						if (field.branching[j].val == i) {
							this.branching.set(Fields.Helpers.getPageIdByPageIndex(field.branching[j].page));
						}
					}
				}
			});
		}
		*/

		/* hack for BooleanField */
		/*
		if (field.branchingOptions) {
			field.branchingOptions.each(function (i) {
				for (var j = 0; j < field.branching.length; j++) {
					if (field.branching[j].val == i) {
						this.set(Fields.Helpers.getPageIdByPageIndex(field.branching[j].page));
					}
				}
			});
		}*/

	},

	removeBranching: function (field){
		/* Takes in a serialized field and strips branching. For use in copy operations. */

		if (field.children && field.children[0]){
			$(field.children).each(function (){
				if (this.branch){
					this.branch = [];
				}
			});
		}

	},

	specialIDs: ['finish', 'terminate', 'redirect', 'random', 'random-range',  'hide', 'email', 'continue', 'mark-complete'],

	getPageIdByPageIndex: function (pageIdx) {
		var survey = require('sma.fs/surveys/editor').Survey.instances[0];

		if (pageIdx == -10) return 'terminate';
		if (this.specialIDs.indexOf(pageIdx) != -1) return pageIdx;
		//if (pageIdx in survey.sectionMapping) return pageIdx;

		return (survey.pages[pageIdx]) ? survey.pages[pageIdx].id : pageIdx;
	},
	getPageIdByPageNumber: function (pageNum) {
		if (this.specialIDs.indexOf(pageNum) != -1) return pageNum;
		return Fields.Helpers.getPageIdByPageIndex(pageNum - 1);
	},

	getPageIndexByPageId: function (pageId) {
		if (pageId == -10) {
			pageId = 'terminate';
		}

		if (this.specialIDs.indexOf(pageId) != -1) return pageId;

		/*if (pageId in Surveys.Survey.instances[0].sectionMapping){
			//Named section
			return pageId;
		}*/

		if (pageId in this.mapping) {
			return this.mapping[pageId].index;
		} else if (parseInt(pageId, 10) == pageId) {
			return pageId;
		}
	},

	getPageNumberByPageId: function (pageId) {
		if (this.specialIDs.indexOf(pageId) != -1) return pageId;
		return Fields.Helpers.getPageIndexByPageId(pageId) + 1;
	}
};

Fields.Natrix = $.klass(Fields.Field, {
	type: 'custom-grid',
	qlass: 'custom-grid',
	cssType: 'custom-grid',

	displayName: gettext('Single Column Grid'),
	helpText: gettext('One answer per row (Dropdown, Text Response, Checkbox, or Radio Buttons)'),
	isEnabled: true,

	isGrouped: true,
	isCustom: true,
	isDynamic: false,
	choiceAppearanceTypes: ['vertical', 'horizontal', 'star', 'combo'],
	getVarContainer: function (index) {
		return (index === undefined) ? $('table.variables tr', this.element): $('table.variables tr', this.element).eq(index);
	},
	getVarLabels: function (index) {
		return $('table.variables tr', this.element).eq(index).find('th .variable');
	},
	getVarFields: function (index) {
		return $('table.variables tr', this.element).eq(index).find('td');
	},
	options: $.extend({},
		Fields.TextField.prototype.options,
		Fields.GridField.prototype.options, {
		firstColSize: Fields.GridField.prototype.options.firstColSize,

		variableList: Class.create(chide.opts.TextList, {
			hasSubOptions: true,
			label: gettext('Variables'),
			enableExtraction: false,
			itemFromValue: function ($super, value) {
				var item = $super(value);
				return $.extend(item, this.field.getVariableSubOptions(value, item));
			},

			renderSubOptions: function ($super, item, index) {
				return this.field.renderVariableSubOptions($super(item, index), item);
			},

			itemAdded: function (item) { this.field.variableAdded(item); },
			itemChanged: function (index, value) { this.field.variableChanged(index, value); },
			itemRemoved: function (index) { this.field.variableRemoved(index); },
			itemsChanged: function (value) { this.field.renderContent(); }
		})
	}),

	initialize: function ($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		if (info.children && info.children.length && info.children) {
			var variables = $.map(info.children, function (el){ return ((['string','dropdown','single','checkbox'].indexOf(el.type) >= 0) ? el:undefined); });
		}
		else {
			var variables = this.getDefaultVariables();
		}

		this.variables = new this.options.variableList({
			field: this,
			value: variables
		});

		this.variables_panel = new Option.Collapsable({
			label: gettext('Variables')
		});

		this.display_panel = new Option.Collapsable({
			label: gettext('Display'),
			collapsed: true
		});

		this.firstColSize = new this.options.firstColSize({
			field: this,
			value: info.questionSize || this.questionSize || 30
		});
	},

	getVariables: function () {
		var that = this;
		return $.map(this.variables.value, function (el, i) {
			return new Variable[{
				'string': 'String',
				'checkbox': 'Boolean',
				'single': 'Single',
				'dropdown': 'Single',
			}[el.type.get()]]($.extend({},{
				id: that.id + '_' + i,
				label: (that.name.get()) ? '{ ' + that.name.get() + '[' + i + '] } ' + el.text.get() : el.text.get(),
				choices: (el.choices) ? $.map(el.choices.value, function (el){return el.text.get();}):undefined
			}));
		});
	},

	getDefaultChoices: function () {
		return [{ label: gettext('Choice 1')}, { label: gettext('Choice 2')}];
	},

	getDefaultVariables: function () {
		return [{
			label: gettext('Variable 1'),
			required: false,
			type: 'string'
		}, {
			label: gettext('Variable 2'),
			required: false,
			type: 'dropdown',
			choices: this.getDefaultChoices()
		}, {
			label: gettext('Variable 3'),
			required: false,
			type: 'single',
			choices: this.getDefaultChoices()
		}];
	},

	getInput: function (variable, index) {
		var type = variable.type.get();
		var appearance = variable.appearance.get();
		if (type == 'string') {
			if (appearance) {
				return $('<textarea>', {'class':'text', 'text': variable.initialValue.get(), 'cols': variable.cols.get(), 'rows': variable.rows.get()});
			} else {
				return $('<input>', {'type':'text', 'class':'text', 'value': variable.initialValue.get(), 'cols':(variable.cols.get()*10 + 'px')});
			}
		} else if (type == 'checkbox') {
			return $('<label class="custom-control custom-checkbox">\
				<input type="checkbox" class="custom-control-input ">\
				<span class="custom-control-indicator"></span></label>');
		} else {
			var id = randomString(10);
			appearance = variable.choiceAppearance.get();
			var input;
			if (type == 'dropdown' || appearance == "combo") {
				input = $('<select>', { 'size': (type=="dropdown") ? undefined:'3', 'class':(type=="dropdown") ? 'choices custom-select':'choices combo' });
				if (type=='dropdown') {
					input.prepend($('<option>', {'class':'dummy', text: variable.blankChoice.get()}));
				}
				$.each(variable.choices.value, function (i, choice) {
					$('<option>', {value: i, html:variable.choices.getAt(i), 'class':'choice label'}).appendTo(input);
				});
			} else if (appearance=="column"){
				input = $($.map(variable.choices.value,function (el, i) {
					return $('<td>', {'class':'choice column-' + index}).append($('<input>', {type:'radio', 'name':id}))[0];
				}));
			} else if (appearance === 'vertical' || appearance === 'horizontal') {
				input = appearance === 'horizontal' ? $('<ul class="d-flex">') : $('<ul>');

				$.each(variable.choices.value, function (i, choice) {
					$('<li class="choice"><label class="custom-control custom-radio">\
						<input name="'+this.id+'" type="radio" class="custom-control-input ">\
						<span class="custom-control-indicator"></span>\
						<span class="custom-control-description">\
						<label for="'+this.id+'">'+ variable.choices.getAt(i) +'</label></span></label></li>'
					).appendTo(input);
				});
			} else {
				input = $('<ul>', { 'class': (appearance == 'star') ? 'choices star':'choices' });
				$.each(variable.choices.value, function (i, choice) {
					$('<li>', {'class': 'choice', css: (appearance == 'horizontal') ? {'float': 'left', 'padding-right': '5px' }: {}})
						.append(
							$('<input>', {type:'radio', 'name':id}),
							$('<span>', {'class': 'label', text:variable.choices.getAt(i)})).appendTo(input);
				});
			}
			return input;
		}
	},
	renderContent: function () {
		var that = this;

		if (this.tableDisplay) {
			this.tableDisplay.remove();
		}

		var table = (this.tableDisplay = $('<table class="variables"></table>'));

		$.each(this.variables.value, function (i) {
			table.append(
				$('<tr>')
					.addClass('align-items-center')
					.append($('<th>')
						.width(that.firstColSize.get() + '%')
						.append($('<span><\/span>')
							.addClass('variable')
							.text(that.variables.getAt(i))
						)
					)
					.append($('<td>')
						.append(that.getInput(that.variables.value[i]))
					)
			);
		});

		table.appendTo(this.element);
	},

	choiceAdded: function (index, value) {
		var variable = this.variables.value[index];
		if (variable.choices.value.length <= 1) {
			this.variableMorphed(index, variable.type.get());
			return true;
		}
		this.getVarFields(index).find('.choices').find('.choice:last').each(function (){
			 	$(this).clone().insertAfter(this)
					.find('.label').addBack().filter('.label').html((value) ? value.text.get() : '').end()
					.find('input, option').addBack().filter('input, option').val(variable.choices.length - 1);
		});
	},
	choiceChanged: function (index, choice, label) {
		this.getVarFields(index).each(function (){
			$(this).find('.choice .label, .choice.label').eq(choice).html(label.text.get());
		});
	},
	choiceRemoved: function (index, choice) {
		this.getVarFields(index).find('.choices').find('.choice:eq(' + choice + ')').remove();
	},
	choicesCleared: function (index) {
		this.variableMorphed(index, this.variables.value[index].type.get());
	},
	blankChoiceChanged: function (index, value){
		this.getVarFields(index).find('select option:first').text(value);
	},
	appearanceChanged: function (index, value) {
		return this.variableMorphed(index, this.variables.value[index].type.get());
	},
	choiceAppearanceChanged: function (index, value, old) {
		return this.variableMorphed(index, this.variables.value[index].type.get());
	},
	variableAdded: function (value) {
		if (this.variables.value.length > 1){
			var input = this.getInput(value, this.variables.value.indexOf(value));
			$('.variables tr', this.element).last().clone()
				.find('th:first .variable').html(value.text.get()).end()
				.find('td').empty().each(function (){$(this).append(input.clone());}).end()
				.appendTo($('.variables', this.element));
		} else {
			this.renderContent();
		}
	},

	variableRemoved: function (index) {
		this.getVarContainer(index).remove();
	},

	variableChanged: function (index, value) {
		this.getVarLabels(index).html(value.text.get());
	},

	variablesCleared: function () {
		this.getVarContainer().remove();
	},

	variableMorphed: function (index, newType, update){
		var variable = this.variables.value[index];

		var input = this.getInput(this.variables.value[index]);
		this.getVarFields(index).empty().each(function (){
			$(this).append(input.clone());
		});
		if (update !== false) {
			$(this.variables.value[index]).trigger('variableMorphed', [newType]);
		}
	},

	renderVariableSubOptions: function (el, child) {
		var that = this;

		var type = child.type.get();

		if (this.isDynamic) {
			this.dynamics = function (fn, scope, args){
				return {
					render: function () {
						return fn.apply(scope, args);
					}
				};
			}(child.dynamics.render, child.dynamics, [child.choices.value]);

			$(child).unbind('choiceChanged').bind('choiceChanged', function (event, choices){
				$(child.dynamics).trigger('choiceChanged', [choices]);
			});
		}

		var result = el;

		child._subOptions = function (type, el){
			var renderedOptions = [];
			var singleColumnGridOptions = [child.validation, child.initialValue, child.restore_default];
			var options = [child.type];

			if (that.isDynamic) {
				var dynamics = Option.renderGroup(gettext('Dynamic Options'), [that.dynamics], true, true);
			}
			else {
				dynamics = undefined;
			}

			options = options.concat({
				'string': [
					child.optional,
					child.appearance,
					Option.renderGroup(gettext('Additional Options'),
						(that.type == "threed-grid")
						? [child.validation, child.initialValue, child.sum, child.sumLabel, child.restore_default]
						: singleColumnGridOptions,
						true, true
					)
				],
				'single': [child.optional, child.choiceAppearance, Option.renderGroup(gettext('Choices'), [child.choices, child.alphabetize, child.randomize], false, true), dynamics],
				'dropdown': [child.optional, child.blankChoice, Option.renderGroup(gettext('Choices'), [child.choices, child.alphabetize, child.randomize], false, true), dynamics],
				'checkbox': []
			}[type]);

			for (var i = 0; i < options.length; i++){
				!!options[i] && renderedOptions.push(options[i].render().hide().appendTo(el));
			}
			return renderedOptions;
		};

		$(child).unbind('variableMorphed').bind('variableMorphed', function (event, newType) {
			result.empty();

			$(child._subOptions(newType, result)).each(function (){
				$(this).fadeIn();
			});
		});

		$(child).trigger('variableMorphed', type);

		return result;
	},

	getVariableSubOptions: function (value, child) {
		var that = this;

		return {
			optional: new chide.opts.Checkbox({
				label: gettext('Optional'),
				value: (value && value.required !== undefined) ? !value.required : true
			}),
			type: new Option.Radio(this, {
				label: gettext('Switch to type:'),
				showLabel: true,
				display: 'dropdown',
				choices: [
					['dropdown', gettext('Dropdown')],
					['string', gettext('Text Response')],
					['checkbox', gettext('Checkbox')],
					['single', gettext('Radio Buttons')]
				],
				value: (value && value.type) || 'string',
				changed: function (val){
					let variableIndex = that.variables.value.indexOf(child);
					this.editor.survey.removeBranchingRulesWithVariable(
						that.id + '_' + variableIndex
					);
					that.variableMorphed(variableIndex, val);
				}
			}),
			choices: new Fields.ChoiceField.prototype.options.choiceList({
				field: this,
				hasSubOptions:true,
				value: (value) ? value.choices : this.getDefaultChoices(),
				extraction: (value && value.extraction) ? value.extraction : undefined,
				itemAdded: function (item) { that.choiceAdded(that.variables.value.indexOf(child), item); },
				itemChanged: function (index, value) { that.choiceChanged(that.variables.value.indexOf(child), index, value); },
				itemRemoved: function (index) { that.choiceRemoved(that.variables.value.indexOf(child), index); },
				itemsChanged: function (value) { that.variableMorphed(that.variables.value.indexOf(child), child.type.get(), false); }
			}),
			choiceAppearance: new Fields.ChoiceField.prototype.options.appearance({
				field: this,
				display: 'dropdown',
				showLabel: true,
				choices: $.map([
					['vertical', gettext("Vertical")],
					['horizontal', gettext("Horizontal (Adjacent Labels)")],
					['column', gettext("Horizontal (Column Labels)")],
					['star', gettext("Star Rating")],
					['combo', gettext("Combo Box")]
				], function (el, i){ return (_(that.choiceAppearanceTypes).contains(el[0])) ? [el]: false;}),
				value: (value && value.choiceAppearance) || "vertical",
				changed: function (value,old) {
					that.choiceAppearanceChanged(that.variables.value.indexOf(child), value, old);
				}
			}),
			alphabetize: new Fields.ChoiceField.prototype.options.alphabetize({
				value: (value && value.alphabetize !== undefined) ? value.alphabetize : false,
				field: child,
				changed: function (value) { if (value) { this.field.randomize && this.field.randomize.set(false).refresh(); } }
			}),
			randomize: new Fields.ChoiceField.prototype.options.randomize({
				value: (value && value.randomize !== undefined) ? value.randomize : false,
				field: child,
				changed: function (value) { if (value) { this.field.alphabetize && this.field.alphabetize.set(false).refresh(); } }
			}),
			appearance: new this.options.appearance({
				field: child,
				value: (value && (value.appearance == 'full' || value.isTextArea)) || false,
				changed: function (val) { that.appearanceChanged(that.variables.value.indexOf(child), val); }
			}),
			sumLabel: new chide.opts.Text({
				displayInline: false,
				label: gettext('Sum Label'),
				value: (value && value.sumLabel) || gettext('The values of column: {x} should add up to {y}. Currently: {z}'),
				help: gettext('Sum Label - The label that will show beneath the question informing the user of the restraint. Place {x}, {y} and {z} in your text and they will be replaced with their appropriate values. Leave blank to show nothing.')
			}),
			sum: new chide.opts.Text({
				displayInline: true,
				allowBlank: true,
				translatable: false,
				label: gettext('Sum'),
				value: (value && value.sum) || undefined,
				help: gettext("About Sum - Sum validates that all answers given add up to a certain value. (Enter '-' to show, but not validate, the sum.)"),
				changed: function (val) { that.sumChanged(that.variables.value.indexOf(child), val); }
			}),
			rows: new this.options.rows({
				field: child,
				value: (value && value.rows) || 5,
				changed: function (val) {
					var index = that.variables.value.indexOf(child);
					that.getVarFields(index).find('input[type="text"], textarea').attr('rows',val);
				}
			}),
			cols: new this.options.cols({
				field: child,
				value:  (value && value.cols) || 20 ,
				changed: function (val) {
					var index = that.variables.value.indexOf(child);
					that.getVarFields(index).find('input[type="text"], textarea').attr('cols',val);
				}
			}),
			initialValue: new this.options.initialValue({
				field: child,
				value: (value && value.initialValue) || '',
				changed: function (val) {
					var index = that.variables.value.indexOf(child);
					that.getVarFields(index).find('input[type="text"], textarea').val(val).text(val);
				}
			}),

			restore_default: new this.options.restore_default({
				field: child,
				value: (value && value.restore_default) || '',
				changed: function (val) {
				}
			}),

			blankChoice: new Fields.DropDownChoiceField.prototype.options.blankChoice({
				value: (value && value.blank_choice) || { en: '---' },
				changed: function (val) {
					that.blankChoiceChanged(that.variables.value.indexOf(child), val);
				}
			}),

			validation: new Validation(this, {
				value: value && value.validation || undefined
			})
		};
	},

	showOptions: function ($super, options) {
		$super(options);
		var that = this;

		var variables = this.variables.render();

		options
			.append(this.variables_panel.render([variables]))
			.append(this.display_panel.render([this.firstColSize.render(),this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render()]));

	},

	serialize: function () {
		var info = Fields.Field.prototype.serialize.call(this);

		info.grouped = true;
		info.custom = true;
		info.questionSize = this.firstColSize.get();
		info.children = [];

		$.each(this.variables.value, function (i, variable) {
			var serialized = $.extend({},{
				label: variable.text.value,
				blank_choice: variable.blankChoice.value,
				appearance: (variable.appearance.get()) ? 'full' : 'default',
				choiceAppearance: variable.choiceAppearance.get(),
				alphabetize: variable.alphabetize.get(),
				rows: variable.rows.get(),
				cols: variable.cols.get(),
				type: variable.type.get(),
				validation: variable.validation.get(),
				initialValue: variable.initialValue.value,
				restore_default: variable.restore_default.get(),
				required: !variable.optional.value,
				choices: $.map(variable.choices.value, function (value) {
					return $.extend({},{
						label: value.text.value,
						score: value.score.value
					});
				})
			});

			if (variable.choices.extraction.question.get()) {
				serialized.extraction = variable.choices.extraction.serialize();
			}

			info.children.push(serialized);
		});

		return info;
	}
});

Fields.ThreeDGridField = $.klass(Fields.Natrix, {
	type: 'threed-grid',
	qlass: 'threed-grid',
	cssType: 'threed-grid',

	displayName: gettext('Multi-column Grid'),
	helpText: gettext('Multiple answers per row (Dropdown, Text Response, Checkbox, or Radio Buttons)'),
	isEnabled: true,
	isCustom: true,

	isGrouped: true,
	extractable: true,
	choiceAppearanceTypes: ['vertical', 'horizontal', 'column', 'star', 'combo'],
	isDynamic: true,

	isScorable: true,

	getVarContainer: function (index) {
		return (index === undefined) ? $('table.variables tr th, table.variables tr td', this.element).filter(':not(.column)') : $('table.variables tr th, table.variables tr td', this.element).filter('.column-'+ index);
	},
	getVarLabels: function (index) {
		return this.getVarContainer(index).filter('th').find('.variable');
	},
	getVarFields: function (index) {
		return this.getVarContainer(index).filter('td');
	},

	options: $.extend({},
		Fields.TextField.prototype.options,
		Fields.GridField.prototype.options,
		Fields.Natrix.prototype.options, {
		rowList: Class.create(Fields.GridField.prototype.options.variableList, {
			itemAdded: function (item) { this.field.rowAdded(item); },
			itemChanged: function (index, value) { this.field.rowChanged(index, value); },
			itemRemoved: function (index) { this.field.rowRemoved(index); }
		})
	}),

	initialize: function ($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		var variableExtraction = info.extraction;
		var rows = [];
		var columns = [];

		if (info.children) {
			$.each(info.children, function (i, variable){
				if (variable.row == 0){
					columns.push({
						label: variable.colname,
						type: variable.type,
						validation: variable.validation,
						appearance: variable.appearance,
						choiceAppearance: variable.choiceAppearance,
						alphabetize: variable.alphabetize,
						randomize: variable.randomize,
						sum: variable.sum,
						sumLabel: variable.sumLabel,
						rows: variable.rows || 5,
						initialValue: variable.initialValue || '',
						restore_default: variable.restore_default || false,
						cols: variable.cols || 20,
						extraction: variable.extraction,
						blank_choice: variable.blank_choice,
						extraction: variable.extraction,
						choices: variable.choices || that.getDefaultChoices(),
						dynamics: variable.dynamics
					});
				}
				if (variable.column == 0){
					rows.push({
						label: variable.label,
						required:  variable.required
					});
				}
			});
		} else {
			rows = [{
				label: gettext('Row 1'),
				required: false
			},  {
				label: gettext('Row 2'),
				required: false
			}];
			columns = [{
				label: gettext('Column 1'),
				type: 'dropdown',
				choices: this.getDefaultChoices()
			}, {
				label: gettext('Column 2'),
				type: 'string',
				choices: this.getDefaultChoices()
			}];
		}

		//for compatibility with version 2.0
		if (info.radioCustom){
			$.each(columns, function (i, column) {
				if (column.type == 'single' || column.type =='dropdown'){
					column.type = 'single';
					column.appearance = 'single';
					column.choiceAppearance = 'column';
				}
			});
		}

		this.unique = new this.options.unique({ value: !!info.unique });

		this.uniqueError = new chide.opts.Text({
			displayInline: false,
			labelClass: '',
			label: gettext('Error Message for Unique Responses.'),
			value: (info && info.uniqueError) || gettext('Responses must be unique.'),
			help: gettext('Unique Responses - The label that will show beneath the question informing the user of the restraint.')
		});

		this.staticcol = new this.options.staticcol({ value: !!info.staticcol });

		this.notUsed = new chide.opts.Checkbox({
			help: gettext("Not Used - Show an additional column that will uncheck all other columns for this row."),
			label: gettext('Show Not Used Column'),
			value: info.showNotUsed || false,
			changed: function (value) {
				$('.na', that.element).css('display','')[(value) ? 'fadeIn' : 'fadeOut']().css('display','');
			}
		});

		this.sumLabel = new chide.opts.Text({
			displayInline: true,
			inputClass: 'text inline medium',
			labelClass: 'inline',
			label: gettext('Sum Label'),
			value: info.sumLabel || gettext('Total'),
			help: gettext('Sum Label - The label that will show in the total row. This will only appear if you have one or more text columns with sum restrictions.'),
			changed: function (value){ that.renderContent(); }
		});

		this.showBorders = new chide.opts.Checkbox({
			help: gettext("Show Borders - Show borders separating the rows and columns of this question (Makes complex 3D matrices easier to understand)"),
			label: gettext('Show Borders'),
			value: info.showBorders !== false
		});

		this.alternateBackground = new chide.opts.Checkbox({
			help: gettext("Alternate Background Colors - Each column in the matrix will have an alternating background color making it stand out from the previous column and easier to understand."),
			label: gettext('Alternate Background Colors'),
			value: info.alternateBackground !== false
		});

		this.notUsedText = new chide.opts.Text({
			label: gettext('Text for "Not Used" column'),
			labelClass: '',
			value: info.notUsedText || gettext('Not Used'),
			changed: function (value) {
				$('.na-text', that.element).text(value);
			}
		});

		this.topLeftText = new chide.opts.Text({
			displayInline: true,
			inputClass: 'text inline medium',
			label: gettext('Top Left Label'),
			labelClass: 'inline',
			value: info.topLeftText || "",
			changed: function (value) {
				$('.top-left-text', that.element).text(value);
			}
		});

		this.randomize = new Fields.GridField.prototype.options.randomize({ field:this, value: !!info.randomize });

		this.alphabetize = new Fields.GridField.prototype.options.alphabetize({ field:this, value: !!info.alphabetize });

		this.rows = new this.options.rowList({
			field: this,
			value: rows,
			extraction: variableExtraction
		});

		this.columns = (this.variables = new this.options.variableList({
			field: this,
			value: columns,
			enableExtraction: false
		}));

		this.columns_panel = new Option.Collapsable({ label: gettext('Columns') });
		this.choices_panel = new Option.Collapsable({ label: gettext('Choices') });
		this.rows_panel = new Option.Collapsable({ label: gettext('Rows') });

		this.options_panel = new Option.Collapsable({ collapsed: true, label: gettext('Options') });
		this.display_panel = new Option.Collapsable({ label: gettext('Display'), collapsed: true });

	},

	getTypes: function () {
		var that = this;

		return $.map(this.variables.value, function (el, i) {
			return {
				type: el.type.get(),
				index: i,
				id: that.id + '[:' + i + ']',
				text: el.text.get(),
				label: (that.name.get()) ? '{ ' + that.name.get() + '[:' + i + '] } ' + el.text.get() : el.text.get(),
				choices: (el.choices) ? $.map(el.choices.value, function (el){return el.text.get();}):undefined
			};
		});
	},

	getRows: function () {
		var that = this;

		var typeLength = this.variables.value.length;

		return $.map(this.rows.value, function (el, i) {
			var items = [];
			for (var j = 0; j < that.columns.value.length; j++) {
				items.push(that.id + '_' + ((typeLength * i) + j));
			}

			return {
				index: i,
				id: that.id + '[' + i + ':]',
				text: el.text.get(),
				items: items,
				label: (that.name.get()) ? '{ ' + that.name.get() + '[' + i + ':] } ' + el.text.get() : el.text.get()
			};
		});
	},

	getVariables: function () {
		var that = this;
		var variables = [];

		$.each(that.getRows(), function (i, rowInfo) {
			$.each(that.getTypes(), function (j, typeInfo) {
				var labelPrefix = (that.name.get()) ? '{ ' + that.name.get() + '[' + rowInfo.index + ':' + typeInfo.index + '] } ' : '';
				variables.push(new Variable[{
					string: 'String',
					checkbox: 'Boolean',
					single: 'Single',
					dropdown: 'Single'
				}[typeInfo.type]]($.extend({},{
					id: that.id + '_' + variables.length,
					label: labelPrefix + rowInfo.text + ' | ' + typeInfo.text,
					choices: typeInfo.choices
				})));
			});
		});

		return variables;
	},

	formatInfo: function ($super) {
		return $.extend($super(), {
			types: this.getTypes(),
			rows: this.getRows()
		});
	},

	renderContent: function () {
		var that = this;
		var old = this.tableDisplay;
		var table = (this.tableDisplay = $('<table class="variables"></table>'));

		var firstRow = $('<tr>')
			.addClass('header')
			.appendTo($('<thead>').appendTo(table));

		$('<th>', {rowspan:2})
			.addClass('top-left-text')
			.html(this.topLeftText.get())
			.width(this.firstColSize.get() + '%')
			.appendTo(firstRow);

		$('<th>', {rowspan:2})
			.addClass('na')
			.addClass('na-text')
			.appendTo(firstRow)
			.html(this.notUsedText.get())
			.css('display', (this.notUsed.get()) ? '' : 'none');
		var choiceHeaders=$('<tr>', {'class':'choiceHeader'}).insertAfter(firstRow);

		var tbody = $('<tbody>').appendTo(table);

		$.each(this.rows.value, function (i) {
			var row = $('<tr>').append($('<th>').html(that.rows.getAt(i))).appendTo(tbody);

			$('<td>', {'class':'na'})
				.append('<input type="checkbox">')
				.css('display', (that.notUsed.get()) ? 'block' : 'none')
				.appendTo(row);
		});
		if (old) {
			old.remove();
		}
		var totalRow = false;
		_.each(this.variables.value, function (el){ if (el.sum.value !== '' && el.sum.value !== undefined) { totalRow = true; } });

		if (totalRow) {
			var row = $('<tr>', {'class': 'total-row'})
				.append($('<th>').html(that.sumLabel.get()))
				.appendTo($('<tfoot>').appendTo(table));
			if (!that.sumLabel.get()) {
				row.css('display', 'none');
			}
			$('<td>', {'class':'na'})
				.css('display', (that.notUsed.get()) ? 'block' : 'none')
				.appendTo(row);
		}
		table.appendTo(this.element);

		_.each(this.variables.value, function (el, i){
			that.buildVariable(i,el.type.get());
		});
	},

	buildVariable: function (index, type) {
		var variable = this.variables.value[index];
		var input = this.getInput(variable, index);
		this.getVarContainer(index).remove();
		$('.variables tr', this.element).each(function (i){
		 	if ($(this).hasClass('header')){
				$('<th>', {'class':'column-'+index}).append($('<span>', {'class':'variable', html:variable.text.get() })).attr('colspan', Math.max((type == 'single' && variable.choiceAppearance.get() == 'column')? variable.choices.value.length:1,1)).insertAfter($((index === 0)? '.na:last':'.column-'+(index-1)+':last',this));
			} else if ($(this).hasClass('total-row')) {
				$('<td>', {'class':'column-'+index}).append($('<span>', {text: (type == 'string' && variable.sum.get()) ? '---' : '' })).attr('colspan', Math.max((type == 'single' && variable.choiceAppearance.get() == 'column')? variable.choices.value.length:1,1)).insertAfter($((index === 0)? '.na:last':'.column-'+(index-1)+':last',this));
			} else if ($(this).hasClass('choiceHeader')){
				var choiceHeaders = $('<tr>');
				if ((type == 'single' && variable.choiceAppearance.get() == 'column') && variable.choices.value.length){
					_.each(variable.choices.value, function (el, j){
						choiceHeaders.append($('<th>', {'class': 'choice column-' + index}).append($('<span>', {'class': ' label', html: variable.choices.getAt(j)})));
					});
				} else {
					choiceHeaders.append($('<th>', {'class': 'column-' + index}));
				}
				if (index === 0) {
					choiceHeaders.contents().prependTo($(this));
				} else {
					choiceHeaders.contents().insertAfter($(this).find('.column-'+(index-1)+':last'));
				}
			} else {
				if (input.is('td,th')) {
					input.clone().insertAfter($((index === 0) ? '.na:last' : '.column-' + (index - 1) + ':last', this));
				} else {
					$('<td>', {'class':'column-' + index}).append(input.clone()).insertAfter($((index === 0) ? '.na:last' : '.column-' + (index - 1) + ':last', this));
				}
			}
		});
	},

	rowAdded: function (value) {
		if (this.rows.value.length > 1){
			$('.variables tbody tr', this.element).last().clone()
				.find('th:first').html(value.text.get()).end()
				.appendTo($('.variables tbody', this.element));
		} else {
			this.renderContent();
		}
	},

	rowRemoved: function (index) {
		$('.variables tbody tr', this.element).eq(index).remove();
	},

	rowChanged: function (index, value) {
		$('.variables tbody tr', this.element).eq(index).find('th:first').html(value.text.get());
	},

	choiceAdded: function ($super, index, value) {
		var variable = this.variables.value[index];
		$(variable).trigger('choiceChanged', [variable.choices.value]);
		if ($super(index, value)) { return; }

		if (variable.type.get() == 'single' && variable.choiceAppearance.get()== 'column') {
			$('.variables tr', this.element).find('.choice.column-' + index +':last').each(function (){
				 	$(this).clone().insertAfter(this)
						.find('.label').html((value) ? value.text.get() : '').end()
						.find('input, option').val(variable.choices.value.length - 1);
			});
			$('.variables tr.header .column-'+(index), this.element).attr('colspan',variable.choices.value.length);
		}
	},

	choiceChanged: function ($super, index, choice, label) {
		var variable = this.variables.value[index];
		$(variable).trigger('choiceChanged', [variable.choices.value]);

		if (variable.type.get()== 'single' && variable.choiceAppearance.get()== 'column') {
			this.getVarContainer(index).filter('.choice').find('.label').eq(choice).html(label.text.get());
		} else {
			$super(index, choice, label);
		}
	},

	choiceRemoved: function ($super, index, choice) {
		var variable = this.variables.value[index];
		$(variable).trigger('choiceChanged', [variable.choices.value]);
		$super(index, index);

		if (variable.type.get() == 'single' && variable.choiceAppearance.get() == 'column') {
			var choiceEl = $('.variables tr', this.element).find('.choice.column-' + index +':eq('+ choice + ')');
			if (variable.choices.value.length === 0) {
				choiceEl.empty();
			} else {
				choiceEl.remove();
			}
			$('.variables tr.header .column-'+(index), this.element).attr('colspan',Math.max(variable.choices.value.length,1));
		}
	},

	variableAdded: function (value) {
		this.variableMorphed(this.variables.value.length-1, value.type.get());
	},

	variableRemoved: function (index) {
		this.getVarContainer(index).remove();
		for (var i= index; i < this.variables.value.length; i++){
			this.getVarContainer(i+1).removeClass('column-'+(i+1)).addClass('column-'+i);
		}
	},

	variableChanged: function (index, value) {
		this.getVarLabels(index).html(value.text.get());
	},

	variablesCleared: function () {
		this.getVarContainer().remove();
	},

	variableMorphed: function ($super, index, newType, update){
		this.buildVariable(index, newType);
		if (update !== false) {
			$(this.variables.value[index]).trigger('variableMorphed', [newType]);
		}
	},

	getVariableSubOptions: function ($super, value, child) {
		var that = this;
		var base = $super(value, child);
		delete base['optional'];
		base.validation.displayInline = true;

		var Dynamics = require('sma.fs/surveys/advanced').Dynamics;

		return $.extend({}, base, {
			dynamics: new Dynamics({
				survey: this.editor.survey,
				value: (value && value.dynamics) ? value.dynamics : undefined,
				field: this
			})
		});
	},

	choiceAppearanceChanged: function (index, value, old) {
		return this.variableMorphed(index, this.variables.value[index].type.get());
	},

	appearanceChanged: function (index, value) {
		return this.variableMorphed(index, this.variables.value[index].type.get());
	},

	sumChanged: function (index, value) {
		return this.renderContent();
	},

	blankChoiceChanged: function (index, value) {
		this.getVarFields(index).find('select option.dummy').text(value);
		return this.renderContent();
	},

	showOptions: function ($super, options) {
		Fields.Field.prototype.showOptions.call(this, options);

		options
			.append(this.columns_panel.render([this.columns.render()]))
			.append(this.rows_panel.render([this.rows.render()]))
			.append(this.display_panel.render([
				this.staticcol.render(),
				this.firstColSize.render(),
				this.topLeftText.render(),
				this.sumLabel.render(),
				this.displayInline.render(),
				this.appendToPrevious.render(),
				this.widthOption.render(),
				this.showBorders.render(),
				this.alternateBackground.render()]))
			.append(this.options_panel.render([
				this.notUsed.render(),
				this.notUsedText.render(),
				this.randomize.render(),
				this.alphabetize.render(),
				this.unique.render(),
				this.uniqueError.render()
			]));
	},

	getExtractionChoices: function () {
		var that = this;

		if (this.rows.extraction.question.get()) {
			return this.rows.extraction.question.getField().getExtractionChoices();
		}

		return $.map(this.rows.value, function (val, i) {
			return [[i, val.text.value]];
		});
	},

	getExtractionOptions: function (config) {
		var that = this;
		this.config = config;
		var columns;
		var choicesSelect;

		var updateChoices = function (values, choices) {
			choicesSelect = new ($.klass(Option.Multiple, {
				render: function ($super) {
					return $super()
						.prepend(this.label);
				}
			}))(this, {
				label: gettext('Choices which should trigger extraction:'),
				help: gettext('Trigger Choices - Choices which should trigger row variable extraction.'),
				value: values,
				choices: choices
			})
			that.column_select.choicesSelect = choicesSelect;
			return choicesSelect.render();
		},

		columns = $.map(this.columns.value, function (val, i) {
			return [[i, val.text.get()]];
		});
		if (config && config.column) {
			if (that.variables.value[config.column].type.value == 'dropdown' || that.variables.value[config.column].type.value == 'single') {
				this.choices = $.map(this.variables.value[config.column].choices.value, function (val, i) {
					return [[i, val.text.get()]];
				});
			} else {
				this.choices = [];
			}
		} else if (that.variables.value[0].type.value == 'dropdown' || that.variables.value[0].type.value == 'single') {
			this.choices = $.map(this.variables.value[0].choices.value, function (val, i) {
				return [[i, val.text.get()]];
			});
		} else {
			this.choices = [];
		}
		this.column_select = new (Class.create(chide.opts.Single, {
			render: function ($super) {
				var rendered = $super();
				if (that.choices.length > 0) {
					if (config && config.choices) {
						this.columnOptions = $('<div/>').append(updateChoices(config.choices, that.choices)).appendTo(rendered);
					} else {
						this.columnOptions = $('<div/>').append(updateChoices([], that.choices)).appendTo(rendered);
					}
				} else {
					this.columnOptions = $('<div/>').appendTo(rendered);
				}
				return rendered;
			}
		}))({
			showLabel: true,
			label: gettext('Column which should trigger extraction:'),
			help: gettext('Column Trigger - Only a single column can be used to trigger extraction.'),
			value: (config) ? config.column : 0,
			choices: columns,
			changed: function (value){
				if (that.variables.value[value].type.value == 'dropdown' || that.variables.value[value].type.value == 'single') {
					that.choices = $.map(that.variables.value[value].choices.value, function (val, i) {
						return [[i, val.text.get()]];
					});
					this.columnOptions.empty();
					this.columnOptions.append(updateChoices([], that.choices));
				} else {
					that.choices = [];
					this.columnOptions.empty();
					that.choicesSelect = undefined;
				}
			}
		})


		this.unique_select = new chide.opts.Checkbox({
			showLabel: true,
			label: gettext('Only extract unique responses'),
			value: (config) ? config.unique : 0
		})

		return new Option.Group(this, {
			options: [this.column_select, this.unique_select]
		});
	},

	serializeExtractionOptions: function (group) {
		if (group.options[0].choicesSelect) {
			choices = $.map(group.options[0].choicesSelect.value, function (val, i) {
					return [val];
			});
		} else {
			choices = [];
		}

		return {
			column: group.options[0].get(),
			choices: choices,
			unique: group.options[1].get()
		};
	},

	serialize: function () {
		// TODO: file upload field
		var that = this;
		var info = Fields.Field.prototype.serialize.call(this);

		info.grouped = info.custom = info.hascolumn = true;
		$.extend(info, {
			showNotUsed: this.notUsed.get(),
			showBorders: this.showBorders.get(),
			alternateBackground: this.alternateBackground.get(),
			notUsedText: this.notUsedText.value,
			topLeftText: this.topLeftText.value,
			sumLabel: this.sumLabel.value,
			randomize: this.randomize.get() || false,
			alphabetize: this.alphabetize.get() || false,
			questionSize: this.firstColSize.get(),
			staticcol: this.staticcol.get(),
			unique: this.unique.get(),
			uniqueError : this.uniqueError.get() || gettext('Responses must be unique'),
			children: [],
			extraction: this.rows.extraction && this.rows.extraction.serialize()
		});

		$.each(this.rows.value, function (i, row) {
			$.each(that.columns.value, function (j, column) {
				var type = column.type.get();
				var choices = undefined;

				if (type === 'dropdown' || type === 'single') {
					choices = [];
					for (var k = 0; k < column.choices.length(); k++) {
						choices.push($.extend({}, {
							label: column.choices.value[k].text.value,
							score: column.choices.value[k].score.value
						}));
					}
				}
				var serialized = $.extend({}, {
					label: row.text.value,
					row: i,
					column: j,
					colname: column.text.value,
					blank_choice: column.blankChoice.value,
					appearance: (column.appearance.get()) ? 'full' : 'default',
					choiceAppearance: column.choiceAppearance.get(),
					alphabetize: column.alphabetize.get(),
					randomize: column.randomize.get(),
					type: column.type.get(),
					validation: column.validation.get(),
					rows: column.rows.get(),
					cols: column.cols.get(),
					sum: column.sum.get(),
					sumLabel: column.sumLabel.value,
					initialValue: column.initialValue.value,
					restore_default: column.restore_default.get(),
					required: !row.optional.value,
					dynamics: column.dynamics.serializeForVariable(column),
					choices: choices
				});

				if (column.choices.extraction.question.get()) {
					serialized.extraction = column.choices.extraction.serialize();
				}

				info.children.push(serialized);
			});
		});

		return info;
	}
});

Fields.DrillDownField = $.klass(Fields.Field, {
	type: 'drill-down',
	qlass: 'drill-down',
	cssType: 'drill-down',

	displayName: gettext('Drill Down'),
	helpText: gettext('Category based choice selection'),
	isEnabled: true,
	isBranchable: true,
	hasChoiceBranching: false,

	isGrouped: true,
	isCustom: true,
	defaultFlipOrder:false,
	defaultLeftLabel: gettext('Left Label'),
	defaultRightLabel: gettext('Right Label'),
	appearanceChoices: [
		['default', gettext('Default')],
		['dropdown', gettext('Dropdown')],
		['likert', gettext('Likert')]
	],

	isScorable: true,

	getDefaultCategories: function () {
		return [{
			label: gettext('Category 1'),
			required: false,
			choices: [{label: gettext('Choice 1') }, { label: gettext('Choice 2') }]
		}, {
			label: gettext('Category 2'),
			required: false,
			choices: [{label: gettext('Choice 1') }, { label: gettext('Choice 2') }]
		}];
	},
	options: $.extend({}, Fields.Field.prototype.options, {
		categoryList: Class.create(chide.opts.TextList, {
			hasSubOptions: true,
			label: gettext('Categories'),
			enableExtraction: false,

			choices: Class.create(Fields.ChoiceField.prototype.options.choiceList, {
				itemFromValue: function ($super, value) {
					return $super((value && value.label) ? value : { label: value });
				},

				// lazy
				itemAdded: function (item) { this.field.choiceAdded(item); },
				itemChanged: function (index, value) { this.field.choiceChanged(index, value); },
				itemRemoved: function (index) { this.field.choiceRemoved(index); },
				itemsChanged: function (value) { this.field.choicesChanged(value); }
			}),

			itemFromValue: function ($super, value) {
				var item = $super(value);

				return $.extend(item, {
					choices: new this.choices({ tabOffset: Math.floor(Math.random() * 60000 + 1), field: this.field, value: (value) ? value.choices : this.field.getDefaultChoices() })
				});
			},

			renderSubOptions: function ($super, item, index) {
				return $super(item, index).append(item.choices.render());
			},

			itemAdded: function (item) { this.field.variableAdded(item); },
			itemChanged: function (index, value) { this.field.variableChanged(index, value); },
			itemRemoved: function (index) { this.field.variableRemoved(index); },
			itemsChanged: function (value) { this.field.renderContent(); }
		}),
		appearance: Class.create(chide.opts.Single, {
			label: gettext('Appearance:'),
			help: gettext('About Appearance - This will determine how the choices and categories to this question will be displayed.'),
			changed: function (value) {
				this.field.likert_options.rendered.toggleClass('collapsed', value == 'likert').children().toggle(value=='likert');
				this.field.choicefield_options.rendered.toggleClass('collapsed', value != 'likert').children().toggle(value!='likert');
				this.field.dropdown_options.rendered.toggleClass('collapsed', value == 'dropdown').children().toggle(value=='dropdown');
				this.field.renderContent();
			},
			initialize: function ($super, config){
				this.choices = config.field.appearanceChoices;
				$super(config);
			}
		}),
		likertLabel: Class.create(chide.opts.Text, {
			inputClass: 'text short',
			changed: function (){this.field.renderContent();}
		}),
		alphabetize: Fields.ChoiceField.prototype.options.alphabetize,
		randomize: Fields.ChoiceField.prototype.options.randomize,
		blankChoice: Fields.DropDownChoiceField.prototype.options.blankChoice
	}),
	buildChoices: function () {
		this.choices.value = $.map(this.categories.value, function (el){
			return el.choices.value;
		});
	},
	initialize: function ($super, info, editor) {
		var that = this;
		info = info || {};
		$super(info, editor);

		var categories, display;
		var hasChild = info.children && info.children[0];
		if (info.children && info.children[0] && info.children[0].categories) {
			categories = info.children[0].categories;
		} else {
			categories = this.getDefaultCategories();
		}

		this.categories = new this.options.categoryList({ field: this, value: categories });
		this.choices = {
			getAt: function (i){return this.value[i].text.get();},
			setAt: function (i,val){return this.value[i].text.set(val);}
		};
		this.buildChoices();

		// convert old branching
		if (this.hasChoiceBranching) {
			var branching = (info.children && info.children.length && info.children[0].branch) ? info.children[0].branch : undefined;
			if (branching) {
				for (var i = 0; i < branching.length; i++) {
					var j = branching[i].val;
					if (j >= 0 && j < this.choices.value.length) {
						this.choices.value[j].branching = new Branching.Simple.Rule({ field: this, value: (branching[i].page) ? branching[i].page : undefined });
					}
				}
			}
		}

		var get_appearance = function (value){
			var choices = $.map(that.appearanceChoices, function (el,i){return el[0];});
			if (value && _(choices).contains(value)) return value;
			else return choices[0];
		};

		this.appearance = new this.options.appearance({ field: this, value: get_appearance(hasChild && info.children[0].display) });

		this.leftLabel = new this.options.likertLabel({ field:this, label:'Left Label', value: (hasChild && info.children[0].leftLabel)? info.children[0].leftLabel : this.defaultLeftLabel});
		this.rightLabel = new this.options.likertLabel({ field:this, label:'Right Label', value: (hasChild && info.children[0].rightLabel)? info.children[0].rightLabel : this.defaultRightLabel});
		this.showCatLabels = new chide.opts.Checkbox({ field:this,
			label: gettext('Show Category Labels'),
			value: (hasChild && info.children[0].showCatLabels != undefined)? info.children[0].showCatLabels : true,
			changed: function (value) { $('tr.category-labels', this.field.rendered).toggle(value); }
		});
		this.flipOrder = new chide.opts.Checkbox({ field:this,
			label: gettext('Flip choice order'),
			value: (hasChild && info.children[0].flipOrder != undefined)? info.children[0].flipOrder : this.defaultFlipOrder,
			changed: function (value) { this.field.renderContent(); }
		});
		this.likert_options = Option.renderGroup('', [this.flipOrder, this.showCatLabels, this.leftLabel, this.rightLabel], (this.appearance.value != 'likert'), true);

		this.randomize = new this.options.randomize({ field:this, value: hasChild && !!info.children[0].randomize });

		this.alphabetize = new this.options.alphabetize({ field:this, value: hasChild && !!info.children[0].alphabetize });

		this.blankChoice = new this.options.blankChoice({ field: this, value: hasChild && info.children[0] && info.children[0].blank_choice || info.blankChoice || undefined })

		this.choicefield_options = Option.renderGroup('', [this.randomize, this.alphabetize], (this.appearance.value == 'likert'), true);

		this.dropdown_options = Option.renderGroup('', [this.blankChoice], (this.appearance.value != 'dropdown'), true);

		this.optional = new this.options.optional({ info: info, changed: function (value) {that.render();} });

		this.options_panel = new Option.Collapsable({
			collapsed: true,
			label: gettext('Options')
		});

		this.categories_panel = new Option.Collapsable({
			label: gettext('Categories')
		});

		this.display_panel = new Option.Collapsable({
			label: gettext('Display'),
			collapsed: true
		});
	},

	getDefaultChoices: function () {
		return [{ label: gettext('Choice 1') }, { label: gettext('Choice 2')}];
	},

	renderContent: function () {
		var that = this;
		var old = this.rendered;

		var rendered = (this.rendered = $('<div/>', { 'class': 'variables drilldown' }));

		let maxScore = 0;
		let numNone = 0;

		for (var i = 0; i < this.choices.value.length; i++) {
			if (this.choices.value[i].score.value !== undefined && this.choices.value[i].score.value != '' && this.choices.value[i].score.value > maxScore) {
				maxScore = this.choices.value[i].score.value;
			} else {
				numNone++;
			}
		}

		if (numNone == this.choices.value.length) {
			for (var i = 0; i < this.categories.value.length; i++) {
				if (this.categories.value[i].choices.value.length > maxScore) {
					maxScore = this.categories.value[i].choices.value.length;
				}
			}
		}

		this.rendered.append($('<div>', {text: gettext('(Score out of ') +  maxScore + ')', 'class': 'sma-score-value'}))

		if (this.appearance.value == 'default') {
			var first = $('<select/>', { 'class': 'drill-down-selector', change: function () { that.refresh(); } })
				.attr('size', 5)
				.appendTo(rendered);

			$('<select/>', { 'class': 'drill-down-selector' })
				.attr('size', 5)
				.appendTo(rendered);

			$.each(this.categories.value, function (i, category) {
				$('<option/>', { html: category.text.get() }).appendTo(first);
			});
		} else if (this.appearance.value == 'dropdown') {
			var select = (this.choiceDisplay = $('<select/>', {'class': 'choices custom-select'}).appendTo(rendered));
			$('<option/>', { html: this.blankChoice.get() }).appendTo(select);
			$.each(this.categories.value, function (i, category) {
				var optgroup = $('<optgroup/>', { label: category.text.get() }).appendTo(select);
				$.each(category.choices.value, function (j, choice) {
					$('<option/>', { html: choice.text.get() }).appendTo(optgroup);
				});
			});
		} else if (this.appearance.value == "likert") {
			var table = $('<table class="variables"></table>').appendTo(rendered);

			var head = $('<thead><tr class="category-labels"><td class="left-side"></td><td class="right-side"></td></tr><tr class="choice-labels"><td class="left-side"></td><td class="right-side"></td></tr></thead>').appendTo(table);

			var body = $('<tbody><tr class="choices"></tr><\/tbody>').appendTo(table);
			$('<td class="left-side"></td>').append($('<span>', {
				'class': 'variable',
				'html': this.leftLabel.get()
			})).appendTo($('tr', body));
			$('<td class="right-side"></td>').append($('<span>', {
				'class': 'rlabel',
				'html': this.rightLabel.get()
			})).appendTo($('tr', body));
			$.each(this.categories.value, function (i, category) {
				that.variableAdded(category);
			});

			if (!this.showCatLabels.value){ $('tr.category-labels',head).hide(); }
		}
		if (old) {
			old.remove();
		}
		rendered.appendTo(this.element);
	},

	refresh: function () {
		var index = $('select:first option', this.rendered)
			.index($('select:first option:selected', this.rendered));

		if (index >= 0) {
			var choiceSelector = $('select:last', this.rendered).empty();

			$.each(this.categories.value[index].choices.value, function (i, choice) {
				$('<option/>', { html: choice.text.get() }).appendTo(choiceSelector);
			});
		}
	},
	choiceAdded: function (value) {
		if (this.appearance.value == 'default') {
			this.refresh();
		} else if (this.appearance.value == "likert") {
			this.renderContent();
		}
		this.buildChoices();
	},
	choiceChanged: function (index, value) {
		if (this.appearance.value == 'default') {
			this.refresh();
		} else if (this.appearance.value == "likert") {
			this.renderContent();
		}
		this.buildChoices();
	},
	choiceRemoved: function (index) {
		if (this.appearance.value == 'default') {
			this.refresh();
		} else if (this.appearance.value == "likert") {
			this.renderContent();
		}
		this.buildChoices();
	},
	choicesChanged: function (value) {
		if (this.appearance.value == 'default') {
			this.refresh();
		} else if (this.appearance.value == "likert") {
			this.renderContent();
		}
		this.buildChoices();
	},
	variableAdded: function (value) {
		var that = this;
		if (this.appearance.value == 'default') {
			$('select:first', this.rendered).append($('<option/>', {
				html: value.text.get()
			}));
		} else if (this.appearance.value == "likert") {
			var action= (!!this.flipOrder.value) ? 'prependTo':'appendTo';
			var vals = $.map(value.choices.value, function (el){ return el; });
			$('<td></td>', {'colspan': vals.length})
				.append($('<span>', {'class':'category', 'html':value.text.get()}))
				[action]($('tr.category-labels', this.rendered));
			$.each(vals, function (i, choice) {
				$('<td></td>')
					.append($('<span>', {'class':'choice', 'html':choice.text.get()}))
					[action]($('tr.choice-labels', that.rendered));
				$('<td></td>')
					.append($('<input>', {'type':'radio', 'name':that.id}))
					[action]($('tr.choices', that.rendered));
			});
			$('td.right-side',this.rendered).each(function (){$(this)[(!that.flipOrder.value)?'appendTo':'prependTo']($(this).parent());});
			$('td.left-side',this.rendered).each(function (){$(this)[(!that.flipOrder.value)?'prependTo':'appendTo']($(this).parent());});
		}
		this.buildChoices();
	},
	variableRemoved: function (index) {
		if (this.appearance.value == 'default') {
			$('select:first option', this.rendered).eq(index).remove();
		} else if (this.appearance.value == "likert") {
			this.renderContent();
		}
		this.buildChoices();
	},
	variableChanged: function (index, value) {
		if (this.appearance.value == 'default') {
			$('select:first option', this.rendered).eq(index).html(this.categories.getAt(index));
		} else if (this.appearance.value == "likert") {
			$('tr.category-labels span.category', this.rendered).eq((!!this.flipOrder.value)?this.categories.value.length-index-1:index).html(this.categories.getAt(index));
		}
		this.buildChoices();
	},

	showOptions: function ($super, options) {
		$super(options);
		var that = this;

		options
			.append(this.categories_panel.render([this.categories.render()]))
			.append(this.display_panel.render([this.appearance.render(),this.likert_options, this.choicefield_options, this.dropdown_options, this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render()]))
			.append(this.options_panel.render([this.optional.render()]));

	},

	getVariables: function () {
		return [new Variable.Single({ id: this.id, label: this.getIdentifier(), choices: $.map(this.choices.value, function (el) { return el.text.get(); }) })];
	},

	serialize: function () {
		var that = this;
		var info = Fields.Field.prototype.serialize.call(this);
		var categories = [];

		info.children = [];
		info.grouped = true;
		info.type = 'question';
		var choiceIndex = 0
		var branch = [];
		$.each(this.categories.value, function (i, category) {
			var choices = [];


			$.each(category.choices.value, function (j, choice) {
				var el = category.choices.value[j];

				choices.push($.extend({}, {
					label: choice.text.value,
					score: choice.score.value
				}));

				if (that.hasChoiceBranching) {
					var page = el.branching.getPage();
					if (page !== undefined) {
						branch.push({ val: choiceIndex, page: page });
					}
				}
				choiceIndex++;
			});

			categories.push({
				label: category.text.value,
				choices: choices
			});
		});
		var question_info = {
			type: 'drill-down',
			categories: categories,
			required: !this.optional.value,
			display: this.appearance.value
		};
		if (branch.length) {
			$.extend(question_info, { branch: branch });
		}

		if (this.appearance.value == 'likert'){
			$.extend(question_info, {
				display: this.appearance.value,
				flipOrder: this.flipOrder.value,
				showCatLabels: this.showCatLabels.value,
				leftLabel: this.leftLabel.value,
				rightLabel: this.rightLabel.value
			});
		} else {
			$.extend(question_info, {
				alphabetize: this.alphabetize.value,
				randomize: this.randomize.value
			});
			if (this.appearance.value == 'dropdown'){
				$.extend(question_info, {
					blank_choice: this.blankChoice.get() && this.blankChoice.value
				});
			}
		}
		info.children.push(question_info);

		return info;
	}
});

Fields.RankingField = $.klass(Fields.SingleChoiceGridField, {
	type: 'ranking',
	qlass: 'ranking',
	cssType: 'ranking',
	isEnabled: true,
	isQuestion: false,
	displayName: gettext('Ranking Question'),
	helpText: gettext('Rank variables by dragging variables and dropping to choices'),
	isBranchable: false,
	initialize: function ($super, info, editor) {
		$super(info, editor);
		this.optional = new this.options.optional({ info: info, changed: function (value) {that.render();} });
	},
	choiceAdded: function (value) {
		$('.choices',this.tableDisplay).append('<div class="choice">'+value.text.get()+'</div>');
	},
	choiceChanged: function (index, value) {
		$('div.choice', this.tableDisplay).eq(index).html(value.text.get());
	},

	choiceRemoved: function (index) {
		$('div.choice', this.tableDisplay).eq(index).remove();
	},
	variableAdded: function (value) {
		$('.variables',this.tableDisplay).append('<div class="variable">'+value.text.get()+'</div>');
	},
	variableChanged: function (index, value) {
		$('div.variable', this.tableDisplay).eq(index).html(value.text.get());
	},

	variableRemoved: function (index) {
		$('div.variable', this.tableDisplay).eq(index).remove();
	},


	renderContent: function () {
		var that = this;
		var old = this.tableDisplay;
		var table = (this.tableDisplay = $('<div class="var-and-choice"></div>'));
		table.append('<div class="variables"><\/div>');
		table.append('<div class="choices"><\/div>');
		for (var j = 0; j < this.choices.length(); j++) {
			this.choiceAdded(this.choices.value[j]);
		}

		for (var j = 0; j < this.variables.length(); j++) {
			this.variableAdded(this.variables.value[j]);
		}

		if (old) {
			old.remove();
		}
		table.appendTo(this.element);
	},
	showOptions: function ($super, options) {
		Fields.Field.prototype.showOptions.call(this, options);
		options
			.append(this.choices_panel.render([this.choices.render()]))
			.append(this.variables_panel.render([this.variables.render()]))
			.append(this.display_panel.render([ this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render()]))
			.append(this.options_panel.render([this.optional, this.randomize.render(), this.alphabetize.render()]));
	},
	serialize: function ($super) {
		var info = $super();
		info.required = !this.optional.value;
		return info;
	}

});

Fields.NetPromoter = $.klass(Fields.DrillDownField, {
	type: 'net-promoter',
	qlass: 'net-promoter',
	cssType: 'net-promoter',
	isBranchable:true,
	displayName: gettext('Net Promoter'),
	helpText: gettext('0 to 10 rating scale'),

	isEnabled: true,
	isCustom: true,
	isVisible: false,
	defaultFlipOrder:true,
	defaultLeftLabel: gettext('Very Likely'),
	defaultRightLabel: gettext('Not at all Likely'),
	appearanceChoices: [
		['likert', gettext('Likert')]
	],

	isScorable: true,

	getDefaultCategories: function () {
		return [{
			label: gettext('Promoter'),
			required: false,
			choices: [{label: '10', score:10}, {label: '9', score:9}]
		}, {
			label: gettext('Passive'),
			required: false,
			choices: [{label: '8', score:8}, {label: '7', score:7}]
		}, {
			label: gettext('Detractor'),
			required: false,
			choices: [{label: '6', score:6}, {label: '5', score:5}, {label: '4', score:4}, {label: '3', score:3}, {label: '2', score:2}, {label: '1', score:1}, {label: '0', score:0}]
		}];
	},
	initialize: function ($super, info, editor) {
		var that = this;
		info = info || {};
		$super(info, editor);
		this.categories.value= this.categories.fromInfo(this.getDefaultCategories());
		this.choices = {
			getAt: function (i){return this.value[i].text.get();},
			setAt: function (i, value){return this.value[i].text.set(value);},
			value: $.map(this.categories.value,function (el){return el.choices.value;})
		};
		this.showCatLabels.set(false);
		this.likert_options = Option.renderGroup('', [this.flipOrder,this.leftLabel, this.rightLabel], (this.appearance.value != 'likert'), true);
		this.display_panel.collapsed=false;
		this.title.value = this.editor.languages.objectify(info.title || gettext('How likely is it that you would recommend our company to a friend or colleague?'));
	},

	showOptions: function (options) {
		Fields.Field.prototype.showOptions.apply(this, [options]);
		var that = this;

		options
			.append(this.display_panel.render([this.likert_options, this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render()]))
			.append(this.options_panel.render([this.optional.render()]));
	}
});

Fields.MultipleChoiceGridField = $.klass(Fields.ChoiceGridField, {
	type: 'multiple-choice-grid',
	qlass: 'multiple-choice-grid',
	cssType: 'multiple-choice-grid',

	isEnabled: true,
	isVisible: false,
	displayName: gettext('Checkbox Grid'),
	helpText: gettext('Multiple checkbox answers per row'),
	isDynamic: true,
	baseType: Variable.Multi,
	extractable: true,

	supportedActions: Fields.Field.prototype.supportedActions.concat([
		Fields.Actions.looping
	]),

	getExtractionChoices: Fields.SingleChoiceGridField.prototype.getExtractionChoices,
	getExtractionOptions: Fields.SingleChoiceGridField.prototype.getExtractionOptions,
	serializeExtractionOptions: Fields.SingleChoiceGridField.prototype.serializeExtractionOptions,

	serializeExtractionOptions: function (options) {
		return {
			choices: (options) ? $.map(options.value, function (i) { return parseInt(i, 10); }) : []
		};
	},

	choiceAdded: function (value) {
		var that = this;
		var choice = $('<td><span class="choice"></span></td>').appendTo(this.tableHeader);

		if (value) {
			$('span.choice', choice).html(value.text.get());
		}

		$('tbody tr', this.tableDisplay).each(function (i) {
			$(this).append('<td><input type="checkbox" name="' + that.id + '_' + i + '"></td>');
		});
	},

	variableAdded: function (value) {
		var row = '<tr><td><span class="variable"></span><\/td>';
		var index = this.variables.length();

		for (var j = 0; j < this.choices.value.length; j++) {
			row += '<td><input type="checkbox" name="' + this.id + '_' + index + '"></td>';
		}

		row = $(row + '<\/tr>');

		if (value) {
			$('span.variable', row).html(value.text.get());
		}

		return row.appendTo($('tbody', this.tableDisplay));
	},

	serializeVariable: function (i, info) {
		return {
			type: 'multiple',
			label: info.text.value,
			required: !info.optional.value
		};
	}
});

// @Deprecated Version from FS/FR
// FR-ONLY
Fields.FileField = $.klass(Fields.Field, {
	type: 'file-field',
	qlass: 'file-field',
	cssType: 'file-field',

	isEnabled: true,
	isVisible: false,

	isCustom: true,

	displayName: gettext('File Upload'),
	options: $.extend({}, Fields.Field.prototype.options),

	initialize: function ($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		if (info.children && info.children.length) {
			var optional = (info.children[0].required !== undefined) ? !info.children[0].required : false;
		} else {
			var optional = true;
		}

		this.optional = new chide.opts.Checkbox({
			label: gettext('Optional'),
			value: optional,
			changed: function (value) {that.render();}
		});

		this.input = $('<input type="file" />');

	},

	render: function ($super) {
		$super();

		if (!this.input) {
			this.input = $('<input type="file" />')
		}

		this.element.append(this.input);
	},

	showOptions: function ($super, options) {
		var that = this;

		$super(options);

		options.append(
			Option.renderGroup(gettext('Display'), [this.displayInline, this.appendToPrevious, this.widthOption], true),
			Option.renderGroup(gettext('Options'), [this.optional, this.remote_upload], false)
		);
	},

	serialize: function ($super) {
		var info = $super();
		info.children = [{
			type: 'file'
		}];

		if (this.optional.value){
			info.children[0].required = false;
		}

		return info;
	}
});

Fields.HiddenField = $.klass(Fields.Field, {
	type: 'hidden-field',
	cssType: 'hidden-field',
	qlass: 'hidden-field',

	displayName: gettext('Hidden Field'),
	isEnabled: true,
	isQuestion: true,
	isBranchable: true,
	isCustom: true,
	initialize: function ($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		if(info.label !== undefined) {
			var label_value = info.label;
		} else {
			var label_value = gettext("Hidden Value");
		}

		this.label = (this.title =new chide.opts.Text({
			label: gettext('Variable Name'),
			value: label_value,
			inputClass: 'text short',
			help: gettext("Variable Name - This value will show up when viewing responses. Note that this question will not be visible anywhere in the survey, and can only be used to pass through a value."),
			changed: function (value) {
				if (value != "")
					$('.title',that.element).text(value);
			}
		}));

		this.initialValue = new chide.opts.Text({
			field: this,
			translatable:false,
			value: info.children && info.children.length && info.children[0].initialValue || info.initialValue || undefined,
			label: gettext('Hidden Value'),
			inputClass: 'text short',
			help: gettext('About Hidden Values - The hidden value allows you to pass through values through your survey. You can pipe values into this field.'),
			changed: function (value) { $('.description', this.field.element).text(value); }
		});

		this.restore_default = new chide.opts.Checkbox({
			label: gettext('Restore Initial Value'),
			value: info.children && info.children.length && info.children[0].restore_default || info.restore_default || undefined,
			help: gettext('About Restore Initial Value - When a user comes back to this form page, this question will have its default value.'),
			changed: function (value) {  }
		});

	},

	getVariables: function () {
		return [new Variable.String({ id: this.id, label: this.getIdentifier(), name: this.name.get() })];
	},

	serialize: function () {
		return $.extend({
			type: 'question',
			id: this.id,
			idname: this.qlass,
			label: this.label.value
		},{
			name: this.name.value || undefined,
			children: [$.extend({}, {
				type: 'hidden',
				initialValue: this.initialValue.get() && this.initialValue.value || undefined,
				restore_default: this.restore_default.get() || undefined
			})]
		});
	},

	render: function () {
		var that = this;

		this.element.empty();

		var options = $('<div class="sma-js-field-actions"></div>')
			.append($(`<a data-variable-name="${this.id}"></a>`))
			.append($('<a href="#" class="nc-icon-mini gestures_drag-31 move" title='+gettext('Move')+'></a>').tooltip())
			.append($('<a href="#" class="nc-icon-mini files_single-copy-04 duplicate" title='+gettext('Duplicate')+'></a>').tooltip())
			.append($('<a href="#" class="nc-icon-mini ui-1_trash-simple remove" title='+gettext('Delete')+'></a>').tooltip());

		this.element.append(options);

		this.element.append(
			'<span class="status"><\/span>',
			'<span class="name">' + ((that.name.get()) ? that.name.get() : '') + '<\/span>',
			'<span class="title fr-view">'+ this.label.get() +'<\/span>',
			'<p class="description fr-view">'+ (this.initialValue.get() || '') +'<\/p>'
		);
	},

	showOptions: function (options) {
		var that = this;

		options.empty()
			.append(this.name.render())
			.append(this.label.render())
			.append(this.initialValue.render())
			.append(this.restore_default.render());
	}
});

Fields.DatasourceField = $.klass(Fields.Field, {
	type: 'datasource',
	cssType: 'datasource',
	qlass: 'datasource',

	displayName: gettext('Datasource Question'),
	isEnabled: true,

	isQuestion: true,
	isBranchable: false,
	isCustom: true,

	options: $.extend({}, Fields.Field.prototype.options, {
		dataSource: Class.create(chide.opts.Text, {
			displayInline: false,
			translatable: false,
			inputClass: 'text inline short',
			label: gettext('Datasource URL'),
			help: gettext('Enter the URL for the datasource here. This URL should return a JSON encoded dictionary (keys will be choice values, values will be choice labels).'),
			inputClass: 'text short'
		}),

		width: Class.create(chide.opts.Number, {
			label: gettext('Width'),
			inputClass: 'text inline medium',
			help: gettext('Question Width - Percentage of the survey width that this question will take up. (This will not be reflected in the editor)'),
			applyEdit: false,
			min: 0,
			max: 200,
			changed: function (value) {
				if (value > 0 && value <= 200) {
					this.field.element.width(value + '%').width(this.field.element.width()-22);
				} else {
					this.field.element.width('auto');
					this.set(100);
				}
			}

		}),

		optional: Class.create(chide.opts.Checkbox, {
			label: gettext('Optional'),
			fromInfo: function (info) {
				if (info && info.required !== undefined)
					return !info.required;
				if (info && info.children && info.children.length)
					return (info.children[0].required !== undefined)? !info.children[0].required : false;
				return true;
			}
		})
	}),

	initialize: function ($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		this.optional = new this.options.optional({ info: info, changed: function (value) {that.render();} });

		this.dataSource = new this.options.dataSource({
			field: this,
			value: info.children && info.children.length && info.children[0].dataSource || info.dataSource || undefined,
			changed: function (value) {
				if (this.field._preview) {
					this.field._preview.text(value);
				}
			}
		});

		this.widthOption = new this.options.width({ value: info.width || 100, field: this });
	},

	render: function ($super) {
		$super();

		this._preview = $('<div></div>', {
			text: this.dataSource && this.dataSource.get(),
			'class': 'datasource'
		});

		this.element.append(this._preview);
	},

	showOptions: function ($super, options) {
		$super(options);

		options.append(
			Option.renderGroup(gettext('Options'), [this.optional, this.dataSource], true),
			Option.renderGroup(gettext('Display'), [this.widthOption], true)
		);
	},

	serialize: function ($super) {
		return $.extend($super(), {
			children: [$.extend({}, {
				type: 'datasource',
				required: !this.optional.value,
				width: this.widthOption.get() || undefined,
				dataSource: this.dataSource.get() && this.dataSource.value || undefined,
			})]
		});
	}
});

Fields.Signature = $.klass(Fields.TextField, {
	type: 'signature',
	qlass: 'signature',
	cssType: 'signature',
	displayName: gettext('Signature'),
	isEnabled: true,
	isBranchable: false,
	isCustom: true,

	options: $.extend({}, Fields.TextField.prototype.options, {

	}),

	showOptions: function ($super, options) {
		var that = this;
		$super(options);

		options.html('');

		options.append(
			Option.renderGroup(gettext('General'), [this.name, this.title, this.description], false))

		options.append(
			Option.renderGroup(gettext('Display'), [this.displayInline, this.appendToPrevious, this.widthOption], true));

		options.append(
			Option.renderGroup(gettext('Options'), [this.optional], true));
	},

	initialize: function ($super, info, editor) {
		$super(info, editor);
		info = info || {};

		$super(info, editor);

		if (info.children && info.children.length) {
			var optional = (info.children[0].required !== undefined) ? !info.children[0].required : false;
		} else {
			var optional = false;
		}

		this.optional = new chide.opts.Checkbox({
			label: gettext('Optional'),
			value: optional,
			changed: function (value) {that.render();}
		});
	},

	serialize: function ($super) {
		var info = $super();
		info.children = [{type:'file'}];

		if (this.optional.value){
			info.children[0].required = false;
		}

		return info;
	},

	getChoiceContainer: function ($super) {
		$super();
	},

	renderContent: function ($super) {
		if($('.signature', this.element).length == 0) {
			this.element.append($('<div\/>', {'class':'signature'}));
			$('.signature',this.element).jSignature({
				signatureLine: true,
				readOnly: true,
				'background-color': '#f4f4f4'
			});
		}
	}
});

Fields.UploadField = UploadField;

module.exports = Fields;
